import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import ReactSummernote from "react-summernote";
import "react-summernote/dist/react-summernote.css";
import { validateFields } from "../Utils/utilities";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { getZoneList } from "../Actions/VendorManagementAPI";
import Role from "../helpers/role";
import Moment from "moment";
import axios from "axios";
import API from "../helpers/api";
import { Card } from "react-bootstrap";
import swal from "sweetalert";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "react-bootstrap/Accordion";
import AddIcon from "../UIComponents/AddIcon";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { MdAddBox } from "react-icons/md";
import { confirmAlert } from "react-confirm-alert";
import Popovers from "react-bootstrap/Popover";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { CssTextField } from "../custom/textField";
import { getHistorySearchlist } from "../Actions/MMPLDashboardAPI";
import Modal from "react-bootstrap/Modal";
import { Paginator } from "primereact/paginator";
import { getApplicableServiceTypeBudgetList } from "../Actions/helpersAPI";
import { getServiceTypeList } from "../Actions/CommonAPI";
import {
  getEquipmentZoneList,
  DownloadComplianceandBudgetList,
  getContractDetails,
} from "../Actions/EquipmentManagementAPI";
import { getShipManagementDetails } from "../Actions/ShipManagementAPI";
import $ from "jquery";
import { getShipDeatil } from "../Actions/ShipEquipmentDetailsAPI";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));
let userrole = localStorage.getItem("UserRoles");
const baseUrl = process.env.REACT_APP_CONTRACT_PAGE_URL;

class BudgetListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFile: false,
      break: false,
      panel_break: false,
      isDuplicate: false,
      isNewBudget: false,
      isWorldwideBudget: false,
      isShore: false,
      isShip: false,
      selectZoneModalIsOpen:false,
      modalIsOpen: false,
      contractmodalIsOpen: false,
      termsmodalIsOpen: false,
      serviceprovidermodalIsOpen: false,
      isNonContractVisible: false,
      isWorldWide: [],
      Budgetable: [],
      Compliancetable: [],
      ComplianceApplicableYears: [],
      NonContractTable:[],
      NonContractApplicableYears:[],
      BudgetTableHistoryHead: [],
      BudgetTableHistoryBody: [],
      AddDynamicLabel: [],
      ServiceProviderInfo: {
        date: "",
        name: "",
        shipId: 0,
        orderId:0,
        worldwide: "",
        signature: "",
        signatureName: "",
        },
      SignatureFile: "",
      ApproverShipInfo: {
        remark: "",
      },
      searchData: {
        toMail: "",
        ccMail: "",
        link: "",
        serviceDetails: [
          {
            id: 1,
            service: "",
            standardPrice: "",
          },
        ],
        mandatoryToTSI:false,
        mandatoryNC:false,
        mandatoryNCText:""
      },
      worldwidevalue: "",
      AddBudget: {
        ZoneName: "",
        ZoneValue: "",
      },
      InvalidToMail: [],
      InvalidCCMail: [],
      tomail: [],
      ccmail: [],
      selectedZone:[],
      isSelectZone:false,
      SelectedorderId:0,
      NewDescription:"",
      verifytomail: [],
      verifyccmail: [],
      isbothContract:true,
      isContract:false,
      isNotContract:false,
      isFilterApply:false,
      ApproverInfo: {
        Date: "",
        remark: "",
        ZoneName: "",
        orderId: "",
        ShipId: 0,
      },
      shipInfo: {
        remarks: "",
        shipId: 0,
        contractId: 0,
        shipName: "",
        flag: "",
        class: "",
        firePlanName: "",
        firePlanGUID: "",
        grt: "",
        imoNo: "",
        status: "",
        deadWeight: "",
        dateOfBuild: "",
        enrollmentDate: "",
        approverId: 0,
        grantAdminId: 0,
        typeOfShip: "",
        shipEmail: "",
        invoiceForwardingEmail: "",
        vesselGroupEmail: "",
        phone1: "",
        phone2: "",
        companyName: "",
        contractName: "",
        contractStatus: "pending",
        modifiedBy: currentUser.name,
        isDeleted: false,
        shipUsers: [],
        ServiceDatePickerIsOpen: false,
      },
    };
    this.handleDateofBuild = this.handleDateofBuild.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  async componentDidMount() {
    const { dispatch, match, t } = this.props;
   if( match.path==="/Home/ContractListEdit/:id"){
    dispatch({
      type: "SubBannerTitle",
      data: "Contract Overview",
    });
   }else{
    dispatch({
      type: "SubBannerTitle",
      data: "Compliance Overview",
    });
   }
   const Id = parseInt(match.params.id);
   if( match.path==="/Home/BudgetListEdit/:id"){
    this.getEquipmentComplianceList(Id,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
   }else{
    this.getEquipmentComplianceList(Id,true,false,false);
   }
  
    window.addEventListener("resize", this.resize.bind(this));
    window.addEventListener("resize", this.panelresize.bind(this));
   // console.log("componentDidMount");
    this.resize();
    this.panelresize();
  }
  resize() {
    if (window.innerWidth < 455) {
      this.setState({
        break: true,
      });
    } else {
      this.setState({
        break: false,
      });
    }
  }
  panelresize() {
    if (window.innerWidth < 1000) {
      this.setState({
        panel_break: true,
      });
    } else {
      this.setState({
        panel_break: false,
      });
    }
  }
  componentDidUpdate(prevProps) {
    window.onpopstate = (e) => {
      //your code...
      const { dispatch, match } = this.props;
      const Id = parseInt(match.params.id);
      if( match.path==="/Home/BudgetListEdit/:id"){
      this.getEquipmentComplianceList(Id,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
      }else{
        this.getEquipmentComplianceList(Id,true,false,false);
       }this.props.dispatch({ type: "ShowSidePan", data: false });
     // console.log("componentDidUpdate");
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { EquipmentArray, dispatch, ShipDetails } = nextProps;
    if (ShipDetails && ShipDetails !== "") {
      prevState.shipInfo.shipId = ShipDetails.shipId;
      prevState.shipInfo.shipName = ShipDetails.shipName;
      prevState.shipInfo.imoNo = ShipDetails.imoNo;
      prevState.fileName = ShipDetails.firePlanName;
      prevState.shipInfo.flag = ShipDetails.flag;
      prevState.shipInfo.class = ShipDetails.class;
      prevState.shipInfo.grt = ShipDetails.grt;
      prevState.shipInfo.typeOfShip = ShipDetails.typeOfShip;
      prevState.shipInfo.dateOfBuild = Moment(
        new Date(Date.parse(ShipDetails.dateOfBuild))
      ).format("YYYY-MM-DD");
      prevState.shipInfo.enrollmentDate = ShipDetails.enrollmentDate
        ? Moment(new Date(Date.parse(ShipDetails.enrollmentDate))).format(
            "YYYY-MM-DD"
          )
        : "";
      prevState.shipInfo.deadWeight = ShipDetails.deadWeight;
      prevState.shipInfo.shipEmail = ShipDetails.shipEmail;
      prevState.shipInfo.phone1 = ShipDetails.phone1;
      prevState.shipInfo.phone2 = ShipDetails.phone2;
      prevState.shipInfo.invoiceForwardingEmail =
        ShipDetails.invoiceForwardingEmail;
      prevState.shipInfo.vesselGroupEmail = ShipDetails.vesselGroupEmail;
      prevState.shipInfo.companyName = ShipDetails.companyName;
      prevState.shipInfo.contractName = ShipDetails.contractName;
      prevState.shipInfo.contractStatus = ShipDetails.contractStatus;
      prevState.shipInfo.contractId = ShipDetails.contractId
        ? ShipDetails.contractId
        : 0;
      prevState.shipInfo.grantAdminId = ShipDetails.grantAdminId;
      prevState.shipInfo.approverId = ShipDetails.approverId;
      prevState.fleetmanager = ShipDetails.fleetManager;
      prevState.superintendent = ShipDetails.technicalSuperintendent;
      prevState.technicalexecutive = ShipDetails.technicalExecutive;
      if (ShipDetails.contractStatus === "active") {
        prevState.active = true;
      } else if (ShipDetails.contractStatus === "terminated") {
        prevState.terminated = true;
      } else if (ShipDetails.contractStatus === "pending") {
        prevState.pending = true;
      }
      prevState.shipInfo.shipUsers = [
        {
          userName: ShipDetails.fleetManager,
          role: "fleetmanager",
        },
        {
          userName: ShipDetails.technicalSuperintendent,
          role: "superintendent",
        },
        {
          userName: ShipDetails.technicalExecutive,
          role: "technicalexecutive",
        },
      ];
      dispatch({ type: "getShipManagementDetailSuccess", data: "" });
    }
  }
  /*   gotoview = () => {
    const { dispatch, match } = this.props;
    let Id = parseInt(match.params.id);
    this.props.history.push(`/Home/BudgetListView/${Id}`);
  };  */ 
 
/* Toggle function */

contractToggleVisibility = () => {
  this.setState((prevState) => ({ isNonContractVisible: !this.state.isNonContractVisible }));
};
  /* Equipment Filter function */
  handleEquipmentCotractChange=(e)=>{
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    if(e.target.checked){
      this.state.isContract=true;
    }else{
      this.state.isContract=false;
    }
    if(this.state.isContract===true || this.state.isNotContract===true){
      this.state.isbothContract=false;
    }
    if(this.state.isContract===true && this.state.isNotContract===true||this.state.isContract===false && this.state.isNotContract===false){
      this.state.isbothContract=true;
    }
  if(this.state.isContract===true||this.state.isNotContract===true){
      this.state.isFilterApply=true;
    }else if(this.state.isContract===false&&this.state.isNotContract===false){
      this.state.isFilterApply=false;
    }
    this.setState({},()=>{
      this.getEquipmentComplianceList(Id,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
    });
  }

 handleNotEquipmentContractChange=(e)=>{
  const { dispatch, match } = this.props;
  const Id = parseInt(match.params.id);
  if (e.target.checked) {
   this.state.isNotContract=true;
  }else{
    this.state.isNotContract=false;
  }
   if(this.state.isContract===true||this.state.isNotContract===true){
      this.state.isFilterApply=true;
    }else if(this.state.isContract===false&&this.state.isNotContract===false){
      this.state.isFilterApply=false;
    }
    if(this.state.isContract===true || this.state.isNotContract===true){
      this.state.isbothContract=false;
    }
    if(this.state.isContract===true && this.state.isNotContract===true||this.state.isContract===false && this.state.isNotContract===false){
      this.state.isbothContract=true;
    }
    this.setState({},()=>{
      this.getEquipmentComplianceList(Id,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
     
    });
  }
  toggle = (target, item) => {
   this.state.isContract=this.state.isContract;
  this.state.isNotContract=this.state.isNotContract;
    this.setState({
      [target]: !this.state[target],
     });
  };

//select zone function
handleCheckboxInputZoneSelect = (e, str) => {
  const{Budgetable}=this.state;
if (e.target.checked) {
    if (Budgetable.length !== 0) {
   let NewBudgetTable={
    zoneName:str.zoneName,
    price:str.price,
    description:str.description?str.description:"",
   }
   this.state.selectedZone.push(NewBudgetTable)
   this.state.SelectedorderId=str.orderId;
   this.showSelectZoneModal(0, false,str);
   this.setState(
    {},() => {
      //console.log(this.state.selectedZone,this.state.SelectedorderId);
    });}
  } else {
    const filteredZone = this.state.selectedZone.filter((item) => item.zoneName !== str.zoneName);
    this.state.selectedZone=filteredZone
    this.setState({}, () => {
     // console.log(this.state.selectedZone);
    });
  }
};
showSelectZoneModal = (value,data,str) => {
  if(data===true){
    this.setState(
      {
        selectZoneModalIsOpen: !this.state.selectZoneModalIsOpen,
        NewDescription:"",
      },
      () => {
       // console.log(this.state.selectedZone,this.state.SelectedorderId);
      }
    );
  }else{
    const filteredZone = this.state.selectedZone.filter((item) => item.zoneName === str.zoneName);
    this.setState(
      {
        selectZoneModalIsOpen: !this.state.selectZoneModalIsOpen,
        NewDescription:filteredZone?filteredZone:[],
      },
      () => {
        //console.log( this.state.selectedZone,this.state.SelectedorderId);
      }
    );
  }

 
};
postSelectedZone = () => {
  const { dispatch, match,t } = this.props;
  const Id = parseInt(match.params.id);
  let apiUrl = `${API.postselectZoneList}`;
  let data={
    shipId:Id,
    orderId:this.state.SelectedorderId,
    zone:this.state.selectedZone
  }
  axios({
    method: "POST",
    url: apiUrl,
    data: data,
  })
    .then((response) => {
      if (response?.status === 200) {
        this.SubmitApprover();
       }
    })
    .catch((error) => {
      // swal("Error!", "Something went wrong. Please try again.", "warning");
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('CommonText.500ErrorMessage'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
     // console.log("Error in Add selected zones" + error);
    });
};
handleDescriptionInputChange=(e, str)=>{
    let nodeName = e.target.name;
    this.state.NewDescription[0][nodeName] = e.target.value;
    const id = str[0].zoneName;
     this.state.selectedZone.find(v => v.zoneName === id).description = e.target.value;
   /* console.log(this.state.selectedZone)  */
   this.setState({});

}
closeDescriptionmodel=()=>{
  this.setState(
    {
      selectZoneModalIsOpen: !this.state.selectZoneModalIsOpen,
      NewDescription:"",
    },
    () => {
     // console.log(this.state.selectedZone,this.state.SelectedorderId);
    }
  );
}

  showModal = () => {
    this.setState(
      {
        modalIsOpen: !this.state.modalIsOpen,
      },
      () => {
        
      }
    );
  };

  openDuplicate = () => {
    const { Budgetable } = this.state;
    let value = Budgetable.filter(
      (item, index) => index === Budgetable.length - 1
    ).map((k, ind) => k.filter((l) => l.zoneName === "A")).length;
    this.setState((prevState) => ({ isDuplicate: !this.state.isDuplicate }));
  };
  openBudget = () => {
    this.setState(() => ({ isWorldwideBudget: !this.state.isWorldwideBudget }));
  };
  AddNewBudget = () => {
    this.setState(() => ({ isNewBudget: !this.state.isNewBudget }));
  };
  getSingleBudgetList = (id) => {
    const { dispatch } = this.props;
    let url = `${API.getSingleBudgetList}?shipId=${id}`;
    axios
      .get(url)
      .then((response) => {
        if ((response.status = 200)) {
          this.getMultipleBudgetList(id);
        }
      })
      .catch((error) => {});
  };

  getMultipleBudgetList = (id) => {
    const { dispatch } = this.props;
    let url = `${API.getMultipleBudgetList}?shipId=${id}`;
    axios
      .get(url)
      .then((response) => {
        if ((response.status = 200)) {
          this.state.Budgetable = response.data;
          let chars = [];
          var processed = response.data.map((i, index) =>
            i.map((j, index) => chars.push(j.zoneName))
          );
          let result = chars.filter(
            (item, index) => chars.indexOf(item) === index
          );
          let result1 = response.data.filter(
            (item, index) => index !== response.data.length - 1
          );
          this.setState(
            {
              BudgetTableHistoryHead: result,
              BudgetTableHistoryBody: result1,
              isWorldWide: response.data.filter(
                (item, index) => index === response.data.length - 1
              ),
            },
            () => {
              this.GetContractDetails(id);
             
            }
          );
        }
      })
      .catch((error) => {});
  };

  GetContractDetails = (id) => {
    const { dispatch, shipDetail } = this.props;
    let url = `${API.getPanelDetails}?shipId=${id}`;
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getContractPanelDetailSuccess",
          data: response.data,
        });
        if (response.status === 200) {
          this.state.searchData.mandatoryNC=response.data.includeNC;
          this.state.searchData.mandatoryNCText=response.data.ncLabel;
          this.setState({})
          this.GetShipDetails(id);
        }
      })
      .catch((error) => {
        dispatch({
          type: "getContractPanelDetailFailure",
          error: "ERROR",
        });
      });
  };
  GetShipDetails = (shipId) => {
    const { dispatch, ContractPanelDetails } = this.props;
    let url = `${API.ShipDetail}?shipId=${shipId}`;
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipDetailSuccess",
          data: response.data,
        });
        if (response.status === 200) {
          dispatch(getShipManagementDetails(shipId));
          dispatch(getZoneList());
          dispatch(getEquipmentZoneList());
          dispatch(getApplicableServiceTypeBudgetList());
          dispatch(getServiceTypeList());
          this.getAAAServiceDetails(shipId);
          if (response.data.status === "Clientapproved"||(response.data.status==="Initiatecontractpending" &&ContractPanelDetails?.response ==="rejected")) {
            this.getDynamicLabel(shipId);
          }
          if (
            ContractPanelDetails?.contractId === 0 &&
            !ContractPanelDetails?.response &&
            response.data.status === "Initiatecontractpending"
          ) {
            this.PostTermsCondition();
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "GetShipDetailFailure",
          error: "ERROR",
        });
      });
  };
  /* get AAA service details */
  getAAAServiceDetails = (Id) => {
    const { dispatch, match } = this.props;
    let url = `${API.GetAAAServices}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.searchData.mandatoryToTSI = response.data.mandatoryToTSI;
          if(response.data.serviceDetails.length !==0){
            this.state.searchData.serviceDetails=response.data.serviceDetails;
          }
       this.setState({}, () => {
            console.log("serviceList", this.state.searchData);
          });
        }
      })
      .catch((error) => {});
  };
  PostTermsCondition = () => {
    let data1;
    let result = this.state.Budgetable?.filter(
      (item, index) => index === this.state.Budgetable?.length - 1
    );
    data1 = result.map((k, ind) => k.map((i, index) => i.zoneName).join(","));
    result.map((k, ind) =>
      k.map(
        (i, index) => (
          (this.state.ApproverInfo.ShipId = i.shipId),
          (this.state.ApproverInfo.orderId = i.orderId)
        )
      )
    );
    this.state.ApproverInfo.ZoneName = data1.toString();
    this.state.ZoneArray = this.state.ApproverInfo.ZoneName.split(",");
    this.setState({}, () => {
    });

    let data = {
      shipId: this.state.ApproverInfo.ShipId,
      zone: "",
      orderId: this.state.ApproverInfo.orderId,
      date: null,
      remarks: "",
      status: "NotStarted",
      confirmedBy: "",
      sign: "",
    };
    this.updateTermsData(data);
  };

  getEquipmentComplianceList = (id,iscontract,isnotcontract,isboth) => {
    const { dispatch } = this.props;
    let url = `${API.getComplianceList}?shipId=${id}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.Compliancetable = response.data;
          this.state.ComplianceApplicableYears =
            response.data.applicableService;
          this.setState({});
          this.getNonContractEquipmentList(id,false,true,false)
         
        }
      })
      .catch((error) => {});
  };
  getNonContractEquipmentList = (id,iscontract,isnotcontract,isboth) => {
    let url = `${API.getComplianceList}?shipId=${id}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.NonContractTable = response.data;
          this.state.NonContractApplicableYears =response.data.applicableService;
          this.setState({});
          this.getSingleBudgetList(id);
        }
      })
      .catch((error) => {});
  };
  handleServiceInputChange = (e) => {
    let nodeName = e.target.name;
    this.state.ServiceProviderInfo[nodeName] = e.target.value;
    this.setState({});
  };
  handleDateofBuild(date) {
    this.state.ServiceProviderInfo.date = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      ServiceDatePickerIsOpen: false,
    });
  }
  openDatePicker() {
    this.setState({
      ServiceDatePickerIsOpen: !this.state.ServiceDatePickerIsOpen,
    });
  }
  handleBlur() {
    this.setState({
      SeviceDatePickerIsOpen: false,
    });
  }
  handleInputFileChange(event) {
    let _this = this;
    let file = event?.target?.files[0];
    let filename = event?.target?.files[0].name;
    let size = event?.target?.files[0].size;
    var idxDot = filename.lastIndexOf(".") + 1;
    var extFile = filename.substr(idxDot, filename.length).toLowerCase();
        if (extFile=="jpg" || extFile=="jpeg" || extFile=="png"){
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let FileUrl = reader?.result;
      let finalResult = reader?.result.split(",");
      _this.state.AppendixFile = reader?.result;
      _this.state.ServiceProviderInfo["appendix"] = finalResult[1];
      _this.state.ServiceProviderInfo["appendixName"] = filename;
      _this.setState({});
    };
  }
  }
  ClearInput = () => {
    this.state.ServiceProviderInfo.appendixName = "";
    this.state.ServiceProviderInfo.appendix = "";
    this.state.AppendixFile = "";
    this.setState({});
  };
  handleInputFileChange1(event) {
    let _this = this;
    let file = event?.target?.files[0];
    let filename = event?.target?.files[0].name;
    var idxDot = filename.lastIndexOf(".") + 1;
    let size = event?.target?.files[0].size;
    var extFile = filename.substr(idxDot, filename.length).toLowerCase();
   if (extFile=="jpg" || extFile=="jpeg" || extFile=="png"){
   var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let FileUrl = reader?.result;
      let finalResult = reader?.result.split(",");
      _this.state.SignatureFile = reader?.result;
      _this.state.ServiceProviderInfo["signature"] = finalResult[1];
      _this.state.ServiceProviderInfo["signatureName"] = filename;
      _this.setState({});
    };
  }
  }
  ClearInput1 = () => {
    this.state.ServiceProviderInfo.signature = "";
    this.state.ServiceProviderInfo.signatureName = "";
    this.state.SignatureFile = "";
    this.setState({});
  };
  OpenPopup(FieldName) {
    if (FieldName === "Logo") {
      this.state.ServiceProviderInfo.appendixName = "";
      this.state.ServiceProviderInfo.appendix = "";
      this.state.AppendixFile = "";
      this.setState({});
    } else if (FieldName === "Signature") {
      this.state.ServiceProviderInfo.signature = "";
      this.state.ServiceProviderInfo.signatureName = "";
      this.state.SignatureFile = "";
      this.setState({});
    }
  }
  SubmitContract(Field) {
    const { t } = this.props;
    if (Field === "submit") {
      confirmAlert({
        message: `${t("CommonText.SubmitContract")}`,
        buttons: [
          {
            label: `${t("confirmAlertMessage.Yes")}`,
            onClick: () => {
              this.setState(
                {
                  serviceprovidermodalIsOpen:
                    !this.state.serviceprovidermodalIsOpen,
                },
                () => {
                  this.ClearServiceProviderDetails();
                }
              );
            },
          },
          {
            label: `${t("confirmAlertMessage.No")}`,
            onClick: () => {},
          },
        ],
      });
    } else if (Field == "model") {
      this.setState(
        {
          serviceprovidermodalIsOpen: !this.state.serviceprovidermodalIsOpen,
        },
        () => {
          this.ClearServiceProviderDetails();
        }
      );
    }
  }
  handleServiceDetailsInputChange=(e,index)=>{
    let nodeName=e.target.name;
    let AddServiceDetails = this.state.searchData.serviceDetails;
    AddServiceDetails[index][nodeName] = e.target.value;
   this.state.searchData.serviceDetails=AddServiceDetails;
   this.setState({})
  }
  ClearServiceProviderDetails() {
    this.setState({
      ServiceProviderInfo: {
        date: "",
        name: "",
        shipId: 0,
        orderId:0,
        signature: "",
        signatureName: "",
        worldwide:"",
        },
      SignatureFile: "",
    });
  }



  SubmitContractDetails() {
    const { dispatch, EquipmentArray,t } = this.props;
   let WorldwideArray= this.state.isWorldWide[0].filter((item, index) =>item.zoneName === "Worldwide")
    if (
      WorldwideArray.length===0 && this.state.ServiceProviderInfo.worldwide===""||
      this.state.ServiceProviderInfo.name === "" ||
      this.state.ServiceProviderInfo.date === "" ||
      this.state.ServiceProviderInfo.signature === "" /* ||
      this.state.ServiceProviderInfo.appendix === "" */
    ) {
      this.state.ServiceProviderInfo.name === ""
        ? $("#NameErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#NameErrMsg").text("");
      this.state.ServiceProviderInfo.date === ""
        ? $("#DateErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#DateErrMsg").text("");
        WorldwideArray.length===0 && this.state.ServiceProviderInfo.worldwide === ""
        ? $("#WorldwideErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#WorldwideErrMsg").text("");
   /*    this.state.ServiceProviderInfo.appendix === ""
        ? $("#LogoErrMsg").text("This field is required")
        : $("#LogoErrMsg").text(""); */
      this.state.ServiceProviderInfo.signature === ""
        ? $("#SignatureErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#SignatureErrMsg").text("");
      return;
    } else {
      $("#NameErrMsg").text("");
      $("#DateErrMsg").text("");
     /*  $("#LogoErrMsg").text(""); */
      $("#SignatureErrMsg").text("");
      $("#WorldwideErrMsg").text("");
    }
    this.SubmitServiceDetails();
  }
  SubmitServiceDetails = () => {
    const { dispatch, match, t } = this.props;
    var Id = parseInt(match.params.id);
    let WorldwideArray= this.state.isWorldWide[0].filter((item, index) =>item.zoneName === "Worldwide")
    if(WorldwideArray.length !==0){
      this.state.isWorldWide[0].map((i, index) =>(
     this.state.ServiceProviderInfo.orderId= i.orderId))
     this.state.ServiceProviderInfo.shipId=Id;
     this.setState({})
    }else{
      this.state.Budgetable.filter((item, index) =>index === this.state.Budgetable.length - 1).map((k, ind) =>k.map((i, index) =>(
        this.state.ServiceProviderInfo.orderId=i.orderId))
        )
        this.state.ServiceProviderInfo.shipId=Id;
        this.setState({})
    }
    if(this.state.ServiceProviderInfo.worldwide===""){
      this.state.ServiceProviderInfo.worldwide=null;
      this.state.ServiceProviderInfo.shipId=Id;
      this.setState({},()=>{
       // console.log(this.state.ServiceProviderInfo)
      })
    }
    let apiUrl = `${API.PostServiceProviderPTF}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.ServiceProviderInfo,
    }).then((response) => {
      if (response?.status === 200) {
        let apiUrl1=`${API.GetAgreement}?shipId=${Id}`;
        axios
        .get(apiUrl1)
        .then((response) => {
          if (response.status === 200) {
        this.state.shipInfo.status = "active";
        this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
        let url = `${API.getShipDetail}`;
        axios
          .put(url, this.state.shipInfo, {
            headers: {
              key: currentUser.accessToken,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              toast.success(`${t("CommonText.AssignedSuccessfully")}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              dispatch({
                type: "PostShipDetailSuccess",
                data: response.data,
              });
              this.props.history.push(`/Home/PendingShip`);
            }
          })
          .catch((error) => {
            dispatch({
              type: "PostShipDetailFailure",
              data: "error",
            });
          });
        }
      })
      }
    });
  };
  renderPopoverTick(array, ApplicableTypes, Type) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          {ApplicableTypes.makeAndModelService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array)[0]?.type === Type
                ? `${t("ComplianceandBudgetScreen.ModelName")} : ` +
                  ApplicableTypes?.makeAndModelService?.filter(
                    (item) => item?.name === array)[0]?.model: " "}
            </label>)}
          {ApplicableTypes.makeAndModelService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type
                ? `${t("ComplianceandBudgetScreen.MakeName")} : ` +
                  ApplicableTypes?.makeAndModelService?.filter((item) => item?.name === array)[0]?.make: " "}
            </label>
          )}
          {ApplicableTypes.flagService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.flagService?.filter(
                (item) => item?.year === array
              )[0]?.type === Type
                ? `${t("ComplianceandBudgetScreen.FlagName")} : ` +
                  ApplicableTypes?.flagService?.filter((item) => item?.year === array)[0]?.name: " "}
            </label>
          )}
          {ApplicableTypes.classService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.classService?.filter((item) => item?.year === array)[0]?.type === Type
                ? `${t("ComplianceandBudgetScreen.ClassName")} : ` +( 
                ApplicableTypes?.classService?.filter((item) => item?.year === array).length === 0 ? " ": 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((i)=>i.name)) 
                 : " "}
            </label>
          ):""}

          {ApplicableTypes.owner.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.owner?.filter((item) => item?.year === array)[0]
                ?.type === Type
                ? `${t("ComplianceandBudgetScreen.OwnerRequirement")}`
                : ""}
            </label>
          )}

        {ApplicableTypes.miscService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.miscService?.filter((item) => item?.year === array)[0]?.type === Type
                ? `${t("MiscScreenContent.MiscName")} : ` + (
                ApplicableTypes?.miscService?.filter((item) => item?.year === array).length===0 ?"":
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((i)=>i.name))
                : " "}
            </label>
          )}

        </Popovers.Content>
      </Popovers>
    );
  }
  renderPopoverTickShore(array, ApplicableTypes, Type) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          {ApplicableTypes.makeAndModelService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type? `${t("ComplianceandBudgetScreen.ModelName")} : ` +
                  ApplicableTypes?.makeAndModelService?.filter((item) => item?.name === array)[0]?.model
                : " "}
            </label>)}

          {ApplicableTypes.makeAndModelService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type ? `${t("ComplianceandBudgetScreen.MakeName")} : ` +
                  ApplicableTypes?.makeAndModelService?.filter((item) => item?.name === array)[0]?.make
                : " "}
            </label>
          )}

          {ApplicableTypes.flagService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.flagService?.filter(
                (item) => item?.year === array)[0]?.type === Type? `${t("ComplianceandBudgetScreen.FlagName")} : ` +
                  ApplicableTypes?.flagService?.filter(
                    (item) => item?.year === array
                  )[0]?.name
                : " "}
            </label>
          )}

          {ApplicableTypes.classService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.classService?.filter((item) => item?.year === array)[0]?.type === Type? 
              `${t("ComplianceandBudgetScreen.ClassName")} : ` + (
                ApplicableTypes?.classService?.filter((item) => item?.year === array).length === 0 ? " ": 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((i)=>i.name))
                : " "}</label>)}

          {ApplicableTypes.owner.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.owner?.filter((item) => item?.year === array)[0]
                ?.type === Type
                ? `${t("ComplianceandBudgetScreen.OwnerRequirement")}`
                : ""}
            </label>
          )}
             {ApplicableTypes.miscService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.miscService?.filter((item) => item?.year === array)[0]?.type === Type
                ? `${t("MiscScreenContent.MiscName")} : ` + (
                 ApplicableTypes?.miscService?.filter((item) => item?.year === array).length===0 ?"":
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((i)=>i.name))
                : " "}</label>)}

        </Popovers.Content>
      </Popovers>
    );
  }
  renderPopover(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("ComplianceandBudgetScreen.EditBudget")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderAddnewbudget(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("ComplianceandBudgetScreen.AddBudget")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  rendernewbudget(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("ComplianceandBudgetScreen.AddWorldwideBudget")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  toggleVisibiliti = () => {
    this.setState((prevState) => ({ isFile: !this.state.isFile }));
  };
  handleCheckboxInputChange = (e, year, applicableyear, str, type) => {
    const { t,match } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.Checkboxservicetype")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { applicableServiceTypeBudget } = this.props;
            const { Compliancetable } = this.state;
            let result = applicableServiceTypeBudget.filter(
              (item) => item.serviceTypes === year
            );
            let data = {
              shipId: Compliancetable.shipId,
              equipmentId: str.equipmentId,
              equipmentName: str.equipmentName,
              isShip: type === "ship" ? true : false,
              isShore: type === "shore" ? true : false,
              serviceYear: result[0].serviceTypes,
              serviceYearId: result[0].id,
              remarks: str.remarks,
              isDeleted: applicableyear ? true : false,
            };
            match.path==="/Home/BudgetListEdit/:id" ?(
            this.updatecomments(data)):this.contractupdatecomments(data)
            /*   if (e.target.checked) { */
            $(".checkboxesship").prop("checked", false);
            /*   } */
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {
            $(".checkboxesship").prop("checked", false);
          },
        },
      ],
    });
  };
  handleContractCheckboxInputChange = (e, year, applicableyear, str, type) => {
    const { t,match } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.Checkboxservicetype")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { applicableServiceTypeBudget } = this.props;
            const { NonContractTable } = this.state;
            let result = applicableServiceTypeBudget.filter(
              (item) => item.serviceTypes === year
            );
            let data = {
              shipId: NonContractTable.shipId,
              equipmentId: str.equipmentId,
              equipmentName: str.equipmentName,
              isShip: type === "ship" ? true : false,
              isShore: type === "shore" ? true : false,
              serviceYear: result[0].serviceTypes,
              serviceYearId: result[0].id,
              remarks: str.remarks,
              isDeleted: applicableyear ? true : false,
            };
           
            this.contractupdatecomments(data)
            $(".checkboxesship").prop("checked", false);
          
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {
            $(".checkboxesship").prop("checked", false);
          },
        },
      ],
    });
  };
  handleInputChangeRemark = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "remarks") {
      this.state.shipInfo.remarks = e.target.value;
      this.setState({});
    }
  };
  handleZoneChange(e) {
    let nodeName = e.target.name;
    this.state.AddBudget[nodeName] = e.target.value;
    this.setState({});
  }
  handleInputChange = (e, str) => {
    let data = this.state.Compliancetable.equipments.map((i, ind) =>
      i.equipmentId == str.equipmentId ? (str.remarks = e.target.value) : ""
    );
    this.setState({});
  };
  UpdateRemarks = (e, str) => {
    const{match}=this.props;
    const { Compliancetable } = this.state;
    let data = {
      shipId: Compliancetable.shipId,
      equipmentId: str.equipmentId,
      equipmentName: str.equipmentName,
      isShip: false,
      isShore: false,
      serviceYear: "",
      serviceYearId: 0,
      remarks: e.target.value.trim(),
    };
    match.path==="/Home/BudgetListEdit/:id" ?(
    this.updatecomments(data)):this.contractupdatecomments(data);
  };
  handleNonContractInputChange = (e, str) => {
    let data = this.state.NonContractTable.equipments.map((i, ind) =>
      i.equipmentId == str.equipmentId ? (str.remarks = e.target.value) : ""
    );
    this.setState({});
  };
  UpdateNonContractRemarks = (e, str) => {
    const{match}=this.props;
    const { NonContractTable } = this.state;
    let data = {
      shipId: NonContractTable.shipId,
      equipmentId: str.equipmentId,
      equipmentName: str.equipmentName,
      isShip: false,
      isShore: false,
      serviceYear: "",
      serviceYearId: 0,
      remarks: e.target.value.trim(),
    };
   this.contractupdatecomments(data)
  };
  contractupdatecomments = (data) => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let apiUrl = `${API.getComplianceList}`;
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
        this.getEquipmentComplianceList(Id,true,false,false);
          this.getNonContractEquipmentList(Id,false,true,false)
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };

  updatecomments = (data) => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let apiUrl = `${API.getComplianceList}`;
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
         this.getEquipmentComplianceList(Id,this.state.isContract,this.state.isNotContract,this.state.isbothContract)
          this.getNonContractEquipmentList(Id,false,true,false)
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };

  handleInputChange1 = (e, str) => {
    var pattern = /^[0-9]*\.?[0-9]*$/;
    if (pattern.test(e.target.value)) {
      let data = this.state.Budgetable.map((item, index) =>
        item.map((k) =>
          k.orderId == str.orderId ? (str.price = e.target.value) : ""
        )
      );
      this.setState({}, () => {
       // console.log(this.state.Budgetable);
      });
    }
  };
  UpdateBudget = (e, str) => {
    const { match } = this.props;
    let data = {
      shipId: str.shipId,
      orderId: str.orderId,
      zoneName: str.zoneName,
      price: e.target.value,
      modifiedBy: currentUser.email,
    };
    this.updateprice(data);
  };
  handleInputChangeWorld = (e, str) => {
    var pattern = /^[0-9]*\.?[0-9]*$/;
    if (pattern.test(e.target.value)) {
      this.state.worldwidevalue = e.target.value;
      this.setState({}, () => {
       // console.log(this.state.Budgetable);
      });
    }
  };
  handleInputChangeNewBudget = (e, str) => {
    var pattern = /^[0-9]*\.?[0-9]*$/;
    if (pattern.test(e.target.value)) {
      this.state.AddBudget.ZoneValue = e.target.value;
      this.setState({}, () => {
       // console.log(this.state.AddBudget.ZoneValue);
      });
    }
  };
  ApproveBudget = (e) => {
    const { dispatch, match, EquipmentArray, t } = this.props;
    if (this.state.shipInfo.remarks === "") {
      this.state.shipInfo.remarks === ""
        ? $("#chargeRemarkErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        : $("#chargeRemarkErrMsg").text("");

      return;
    } else {
      $("#chargeRemarkErrMsg").text("");
    }
    if (this.state.Budgetable.length === 0) {
      // swal("Error!", `${t("CommonText.BudgetAdd")}`, "warning");
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t("CommonText.BudgetAdd"),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    } else {
      confirmAlert({
        message: `${t("confirmAlertMessage.ApproveBudget")}`,
        buttons: [
          {
            label: `${t("confirmAlertMessage.Yes")}`,
            onClick: () => {
              this.state.shipInfo.status = "Initiatecontractpending";
              this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
              this.setState({});
              let url = `${API.getShipDetail}`;
              axios
                .put(url, this.state.shipInfo, {
                  headers: {
                    key: currentUser.accessToken,
                  },
                })
                .then((response) => {
                  if (response.status === 200) {
                    toast.success(t('CommonText.AssignedSuccessfully'), {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    dispatch({
                      type: "PostShipDetailSuccess",
                      data: response.data,
                    });
                    this.props.history.push(`/Home/PendingShip`);
                  }
                })
                .catch((error) => {
                  dispatch({
                    type: "PostShipDetailFailure",
                    data: "error",
                  });
                });
            },
          },
          {
            label: `${t("confirmAlertMessage.No")}`,
            onClick: () => {},
          },
        ],
      });
    }
  };
  RejectBudget = (e) => {
    const { dispatch, match, EquipmentArray, t } = this.props;
    if (this.state.shipInfo.remarks === "") {
      this.state.shipInfo.remarks === ""
        ? $("#chargeRemarkErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
        : $("#chargeRemarkErrMsg").text("");
      return;
    } else {
      $("#chargeRemarkErrMsg").text("");
    }
    confirmAlert({
      message: `${t("confirmAlertMessage.RejectBudget")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            this.state.shipInfo.status = "pending";
            this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
            this.setState({})
            let url = `${API.getShipDetail}`;
            axios
              .put(url, this.state.shipInfo, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                if (response.status === 200) {
                  toast.success(`${t("CommonText.AssignedSuccessfully")}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  dispatch({
                    type: "PostShipDetailSuccess",
                    data: response.data,
                  });
                  this.props.history.push(`/Home/PendingShip`);
                }
              })
              .catch((error) => {
                dispatch({
                  type: "PostShipDetailFailure",
                  data: "error",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {},
        },
      ],
    });
  };
  AssignGrandAdmin(){
    const { t } = this.props;
    confirmAlert({
            message: `${t("ShipManagementContent.CoordinatorMsg")}`,
            buttons: [
              {
                label: `${t("confirmAlertMessage.Yes")}`,
                onClick: () => {
                  const { dispatch } = this.props;
                  this.state.shipInfo.status = "pending";
                  this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
                  this.setState({});
                  let url = `${API.getShipDetail}`;
                  axios
                    .put(url, this.state.shipInfo, {
                      headers: {
                        key: currentUser.accessToken,
                      },
                    })
                    .then((response) => {
                      if (response.status === 200) {
                       toast.success(`${t("CommonText.AssignedSuccessfully")}`, {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                        this.props.history.push(`/Home/PendingShip`);
                        dispatch({
                          type: "PostShipDetailSuccess",
                          data: response.data,
                        });
                      }
                    });
                },
              },
              {
                label: `${t("confirmAlertMessage.No")}`,
                onClick: () => {},
              },
            ],
          });
      }
  UpdateNewBudget = (e) => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let data = {
      shipId: Id,
      orderId: 0,
      zoneName: this.state.AddBudget.ZoneName,
      price: this.state.AddBudget.ZoneValue,
      modifiedBy: currentUser.email,
    };
    this.updateBudgetData(data);
    this.state.isNewBudget = false;
    this.setState({});
  };
  updateBudgetData(data) {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let apiUrl = `${API.getSingleBudgetList}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.getMultipleBudgetList(Id);
          this.state.AddBudget = {
            ZoneName: "",
            ZoneValue: "",
          };
          this.setState({});
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  }
  /*   onChange(content) {
    console.log("HTML", content);
  } */

  UpdateBudgetworld = (e, str) => {
    const { match } = this.props;
    let data = {
      shipId: str.shipId,
      orderId: str.orderId,
      zoneName: "Worldwide",
      price: e.target.value,
      modifiedBy: currentUser.email,
    };
    this.updateprice(data);
    this.state.isWorldwideBudget = false;
    this.setState({});
  };
  updateprice = (data) => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let apiUrl = `${API.getSingleBudgetList}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.getMultipleBudgetList(Id);
          this.state.isDuplicate = false;
          this.state.worldwidevalue = "";
          this.setState({});
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
  validateToEmail = async (email) => {
    email.map((item) => {
      if (item !== "") {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (item.match(mailformat)) {
        } else {
          var c = this.state.InvalidToMail.push(item);
          this.setState(
            {
              InvalidToMail: this.state.InvalidToMail,
            },
            () => {
             // console.log(this.state.InvalidToMail);
              //console.log(this.state.tomail);
            }
          );
        }
      }
    });
  };
  validateCcEmail = async (email) => {
    email.map((item) => {
      if (item !== "") {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (item.match(mailformat)) {
        } else {
          var e = this.state.InvalidCCMail.push(item);
          this.setState(
            {
              InvalidCCMail: this.state.InvalidCCMail,
            },
            () => {
             // console.log(this.state.InvalidCCMail);
              //console.log(this.state.ccmail);
            }
          );
        }
      }
    });
  };
  /* Non contract select code */
  isNonContractApplicable = (e, i) => {
    if (e.target.checked) {
      this.state.searchData.mandatoryNC = true;
      this.setState({ }); }
   else{
     this.state.searchData.mandatoryNC= false;
    this.setState({  });
   }};

   handleInputChangeText = (e) => {
    this.state.searchData.mandatoryNCText = e.target.value;
    this.setState({});
  };
  /* AAA Service details checkbox select code */
  isServiceApplicable = (e, i) => {
    if (e.target.checked) {
      this.state.searchData.mandatoryToTSI = true;
      this.setState({ }); }
   else{
     this.state.searchData.mandatoryToTSI= false;
    this.setState({  });
   }};

  postBudegetList = () => {
    let data1;
    let result = this.state.Budgetable?.filter(
      (item, index) => index === this.state.Budgetable?.length - 1
    );
   // console.log(result);
    data1 = result.map((k, ind) => k.map((i, index) => i.zoneName).join(","));
    result.map((k, ind) =>
      k.map(
        (i, index) => (
          (this.state.ApproverInfo.ShipId = i.shipId),
          (this.state.ApproverInfo.orderId = i.orderId)
        )
      )
    );
    this.state.ApproverInfo.ZoneName = data1.toString();
    this.state.ZoneArray = this.state.ApproverInfo.ZoneName.split(",");
    this.setState({}, () => {
      //console.log(this.state.ZoneArray);
    });

    let data = {
      shipId: this.state.ApproverInfo.ShipId,
      zone: "",
      orderId: this.state.ApproverInfo.orderId,
      date: this.state.ApproverInfo.Date ? this.state.ApproverInfo.Date : null,
      remarks: this.state.ApproverInfo.remark,
      status: "pending",
      confirmedBy: "",
      sign: "",
    };
    this.updateBudeget(data);
  };

  updateBudeget = (data) => {
    const { t } = this.props;
    let apiUrl = `${API.postBudgetList}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.postSelectedZone()
        }
      })
      .catch((error) => {
        // swal("Error!", "Something went wrong. Please try again.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('CommonText.500ErrorMessage'),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
       // console.log("Error in Add settings Visitor" + error);
      });
  };
  SubmitApprover = async () => {
    const { dispatch, match, shipDetail, t } = this.props;
    this.state.InvalidCCMail = [];
    this.state.InvalidToMail = [];
    let a = [$("div.tomail>input").val()];
    var b = [];
    if (a[0]) {
      b = a.concat(this.state.tomail);
    }
    if (b.length !== 0) {
      this.state.verifytomail = b;
    } else {
      this.state.verifytomail = this.state.tomail;
    }
    if (this.state.verifytomail.length !== 0) {
      if (this.state.searchData.shipName != "") {
        await this.validateToEmail(b);
       // console.log(this.state.InvalidToMail.length);
        if (this.state.InvalidToMail.length > 0) {
          // swal("Error!", `${t("CommonText.Invalidapprovermail")}`, "warning");
          swal({
            title: t('SwalError.ErrorTitle'), 
            text: t("CommonText.Invalidapprovermail"),  
            icon: 'warning',  
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
          return;
        }
        let f = [$("div.ccmail>input").val()];
        var g = [];
        if (f[0]) {
          g = f.concat(this.state.ccmail);
        }
        if (g.length !== 0) {
          this.state.verifyccmail = g;
        } else {
          this.state.verifyccmail = this.state.ccmail;
        }
        if (this.state.verifyccmail.length !== 0) {
          await this.validateCcEmail(g);
          if (this.state.InvalidCCMail.length > 0) {
            // swal("Error!", `${t("CommonText.Invalidccmail")}`, "warning");
            swal({
              title: t('SwalError.ErrorTitle'), 
              text: t("CommonText.Invalidccmail"),  
              icon: 'warning',  
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            });
            return;
          }
        }
        if(this.state.searchData.serviceDetails[0].service===""){
          this.state.searchData.serviceDetails=[];
          this.setState({});
        }
        if(this.state.searchData.mandatoryNC===true){
         if(this.state.searchData.mandatoryNCText===""){
          this.state.searchData.mandatoryNCText === ""
          ? $("#noncontracttext").text(`${t("ErrorMessage.RequiredMsg")}`)
          : $("#noncontracttext").text("");
          return;
         }else{
          $("#noncontracttext").text("")
         }
        }
        const Id = parseInt(match.params.id);
        let data = {
          shipId: Id,
          shipName: shipDetail.shipName,
          toApproveMails: this.state.tomail
            ? this.state.tomail.length === 0? null: this.state.tomail.toString(): null,
          ccMails: this.state.ccmail
            ? this.state.ccmail.length === 0? null: this.state.ccmail.toString(): null,
          linkToSend: `${baseUrl}/Home/BudgetListView/${Id}`,
          includeNC: this.state.searchData.mandatoryNC,
          ncLabel: this.state.searchData.mandatoryNCText,
          serviceDetails:this.state.searchData.serviceDetails,
          mandatoryToTSI:this.state.searchData.mandatoryToTSI,
        };
        let apiurl = `${API.sendmailToApproveContract}`;
      axios({
          method: "POST",
          url: apiurl,
          data: data,
        })
          .then((response) => {
         if (response.status === 200) {
                this.state.shipInfo.status = "Clientapprovalpending";
                this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
                this.setState({});
                let url = `${API.getShipDetail}`;
                axios
                  .put(url, this.state.shipInfo, {
                    headers: {
                      key: currentUser.accessToken,
                    },
                  })
                  .then((response) => {
                    if (response.status === 200) {
                      toast.success(
                        `${t(
                          "ComplianceandBudgetScreen.ContractInitiatedSuccessfully"
                        )}`,
                        {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        }
                      );
                      this.state.tomail = [];
                      this.state.ccmail = [];
                      this.state.InvalidCCMail = [];
                      this.state.InvalidToMail = [];
                      this.state.verifytomail = [];
                      this.state.verifyccmail = [];
                      this.state.selectedZone=[];
                      this.state.SelectedorderId=0;
                      dispatch(getContractDetails(Id));
                      dispatch(getShipDeatil(Id));
                      this.setState({ contractmodalIsOpen: false }, () => {
                        this.ClearContractDetails("close");
                      });
                    }
                  })
                  .catch((error) => {
                    // swal(
                    //   "Error!",
                    //   "Something went wrong. Please try again.",
                    //   "warning"
                    // );
                    swal({
                      title: t('SwalError.ErrorTitle'), 
                      text: t('CommonText.500ErrorMessage'),  
                      icon: 'warning',  
                      buttons: {
                        confirm: {
                          text: t('confirmAlertMessage.Ok')
                        }
                      }
                    });
                    //console.log("Error in Add settings Visitor" + error);
                  });
              }
          
          })
          .catch((error) => {
            // swal("Error!", "Something went wrong. Please try again.", "warning");
            swal({
              title: t('SwalError.ErrorTitle'), 
              text: t('CommonText.500ErrorMessage'),  
              icon: 'warning',  
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            });
           // console.log("Error in Add settings Visitor" + error);
          });
      }
    } else {
      // swal(
      //   "Error!",
      //   `${t("ComplianceandBudgetScreen.ToMailismandatory")}`,
      //   "warning"
      // );
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t("ComplianceandBudgetScreen.ToMailismandatory"),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });

    }
  };
  ResendEmail=async()=>{
    const { dispatch, match, shipDetail, t } = this.props;
    const Id = parseInt(match.params.id);
    let data={
      shipId:Id,
      linkToSend: `${baseUrl}/Home/BudgetListView/${Id}`,
    }
    let apiurl = `${API.resendMailToContract}`;
    axios({
      method: "PUT",
      url: apiurl,
      data: data,
    })
      .then((response) => {
        if (response.status === 200 && response.data==="Success") {
          // swal("Success!", "Contract mail sent successfully", "success");
          swal({
            title: t('BudgetListOverview.Success'), 
            text: t("BudgetListOverview.ContractMail"),  
            icon: 'warning',  
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
        }
        else if(response.data==="Failed"){
          // swal("Error!","Something went wrong. Please try again.","warning");
          swal({
            title: t('SwalError.ErrorTitle'), 
            text: t('CommonText.500ErrorMessage'),  
            icon: 'warning',  
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
        }
      }) .catch((error) => {
        // swal(
        //   "Error!",
        //   "Something went wrong. Please try again.",
        //   "warning"
        // );
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('CommonText.500ErrorMessage'),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
       // console.log("Error in Add settings Visitor" + error);
      });
  }
  ClearContractDetails(type) {
    this.state.tomail = [];
    this.state.ccmail = [];
    this.state.InvalidCCMail = [];
    this.state.InvalidToMail = [];
    this.state.verifytomail = [];
    this.state.verifyccmail = [];
    if(type==="open"){
      this.state.searchData = {
        toMail: "",
        ccMail: "",
        link: "",
        serviceDetails:this.state.searchData.serviceDetails,
        mandatoryToTSI:this.state.searchData.mandatoryToTSI,
        mandatoryNC:this.state.searchData.mandatoryNC,
        mandatoryNCText:this.state.searchData.mandatoryNCText
      };
    }else if(type==="close"){
      this.state.searchData = {
        toMail: "",
        ccMail: "",
        link: "",
        serviceDetails: [
          {
            id: 1,
            service: "",
            standardPrice: "",
          },
        ],
        mandatoryToTSI:false,
        mandatoryNC:this.state.searchData.mandatoryNC,
        mandatoryNCText:""
      };
    }
 
    this.setState({});
  }
  showContractModal = () => {
    const { t } = this.props;
    if (this.state.Budgetable.length === 0) {
      // swal(
      //   "Error!",
      //   `${t("ComplianceandBudgetScreen.Pleaseaddabudget")}`,
      //   "warning"
      // );
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t("ComplianceandBudgetScreen.Pleaseaddabudget"),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    } else {
      if(this.state.selectedZone.length===0){
         this.state.selectedZone.length===0? 
         (this.state.isSelectZone = true &&
          // swal("Error!","Please select atleast one zone.","warning")
          swal({
            title: t('SwalError.ErrorTitle'), 
            text: t("BudgetListOverview.PleaseZone"),  
            icon: 'warning',  
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          })
        )
         : (this.state.isSelectZone = false);
       this.setState({});
       return;
      }else{
      this.setState(
        {
          isSelectZone:false,
          contractmodalIsOpen: !this.state.contractmodalIsOpen,
        },
        () => {
          this.ClearContractDetails("open");
        }
      );
      }
    }
  };
  //Back button function

  hideSidePanel = () => {
    const{match}=this.props;
    if( match.path==="/Home/ContractListEdit/:id"){
      this.props.dispatch({ type: "Pendingsearched", data: true });
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.goBack();
    }else{
    this.props.dispatch({ type: "searched", data: true });
    this.props.dispatch({ type: "MapPopup", data: 0 });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }
  };
  //Export excel button function
  ExportExcel = (shipName,iscontract,isnotcontract,isboth) => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    dispatch(DownloadComplianceandBudgetList(Id,shipName,iscontract,isnotcontract,isboth));
  };

//Edit Terms and condition button function

  handleLabelInputChange = (e, i) => {
    let Adddynamiclabel = this.state.AddDynamicLabel;
    Adddynamiclabel[i][e.target.name] = e.target.value;
    this.setState({ Adddynamiclabel });
  };
  handleLabelMandatorySelect = (e, i) => {
    let Adddynamiclabel = this.state.AddDynamicLabel;
    if (e.target.checked) {
      Adddynamiclabel[i][e.target.name] = true;
      this.setState({ Adddynamiclabel }); }
   else{
    Adddynamiclabel[i][e.target.name] = false;
    this.setState({ Adddynamiclabel });
   }};
  getDynamicLabel = () => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let url = `${API.GetCustomField}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200 && response.data.length !== 0) {
          this.state.AddDynamicLabel = response.data;
          this.setState({}, () => {
           // console.log("custom", this.state.AddDynamicLabel);
          });
        }
      })
      .catch((error) => {});
  };
  getTermsandCondition = () => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let url = `${API.GetTermsandCondition}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          var finalresult = atob(response.data);
         // console.log(finalresult);
          window["getsummernote_code"](finalresult);
        }
      })
      .catch((error) => {});
  };

  showEditTermsModal = (data) => {
    if (data === true) {
      this.setState(
        {
          termsmodalIsOpen: !this.state.termsmodalIsOpen,
        },
        () => {
          this.getTermsandCondition();
          window["summernote_addEditDesc"]();
          this.getDynamicLabel();
        }
      );
    } else {
      this.setState(
        {
          termsmodalIsOpen: !this.state.termsmodalIsOpen,
        },
        () => {
          this.ClearTermsCondition();
        }
      );
    }
  };

  miscChargeValidation() {
    const{t}=this.props;
    let validateField = [];
    let inValidComponent = [];
    let miscCharges = this.state.AddDynamicLabel;
    if ($("#chargeDescription0").val() === "") {
      if ($("#chargeDescription0").val() === "") {
        $("#chargeDescription0ErrMsg").text(t("BudgetListOverview.Label"));
      } else {
        $("#chargeDescription0ErrMsg").text("");
      }
      return;
    } else {
      $("#chargeDescription0ErrMsg").text("");
    }
    let indexFrom = $("#chargeDescription0").val() === "" ? 1 : 0;
    miscCharges.forEach((row, index) => {
      if (index >= indexFrom) {
        validateField.push({ Id: `chargeDescription${index}`, Type: "text" });
      }
    });
    const validationResult = validateFields(validateField, true);
    validationResult.InValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text(t("BudgetListOverview.Label"));
    });
    validationResult.ValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("");
    });
    if (validationResult.IsValid === true && inValidComponent.length === 0) {
      return true;
    } else {
      return false;
    }
  }
 AddNewLabel() {
    var arrayStroage = this.state.AddDynamicLabel;
    var arrayLength = arrayStroage.length;
    if (arrayLength > 0) {
      let isValidMiscCharge = this.miscChargeValidation();
      if (!isValidMiscCharge) {
        return;
      }
      this.setState({
        AddDynamicLabel: [
          ...this.state.AddDynamicLabel,
          {
            Id: arrayLength + 1,
            labelName: "",
            labelValue: "",
            isMandatory:false,
          },
        ],
      });
    } else {
      this.setState({
        AddDynamicLabel: [
          ...this.state.AddDynamicLabel,
          {
            Id: arrayLength + 1,
            labelName: "",
            labelValue: "",
            isMandatory:false,
          },
        ],
      });
    }
  }
  submitTermsCondition = () => {
    const { match, t } = this.props;
    const Id = parseInt(match.params.id);
    let result = window["getsummernote_code"]();
    let result1 = window.btoa(unescape(encodeURIComponent(result)));
    if (this.state.AddDynamicLabel.length !== 0) {
      let isValidMiscCharge = this.miscChargeValidation();
      if (!isValidMiscCharge) {
        return;
      }
    }
    let data = {
      shipId: Id,
      tandC: result1,
    };
    let data1 = {
      shipId: Id,
      customString: this.state.AddDynamicLabel,
    };
   // console.log("value", this.state.AddDynamicLabel, Id, result1);
    let url = `${API.PutTermsCondition}`;
    axios
      .put(url, data)
      .then((response) => {
        if (response.status === 200) {
          let url1 = `${API.PutCustomField}`;
          axios
            .put(url1, data1)
            .then((response) => {
              if (response.status === 200) {
                this.setState(
                  {
                    termsmodalIsOpen: !this.state.termsmodalIsOpen,
                  },
                  () => {
                    this.ClearTermsCondition();
                  }
                );
                toast.success(`${t("CommonText.CommonUpdate")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {});
  };
  ClearTermsCondition() {
    var arrayStroage = this.state.AddDynamicLabel;
    var arrayLength = arrayStroage?.length;
    this.setState({
      AddDynamicLabel: [],
    });
  }
  miscChargeValidation1() {
    const{t}=this.props;
    let validateField = [];
    let inValidComponent = [];
    let miscCharges = this.state.searchData.serviceDetails;
    if ($("#service0").val() === ""||$("#standardprice0").val()==="") {
      if ($("#service0").val() === "") {
        $("#service0ErrMsg").text(t('ErrorMessage.RequiredMsg'));
      } else {
        $("#service0ErrMsg").text("");
      }
      if ($("#standardprice0").val() === "") {
        $("#standardprice0ErrMsg").text(t('ErrorMessage.RequiredMsg'));
      } else {
        $("#standardprice0ErrMsg").text("");
      } 
      return;
    } else {
      $("#service0ErrMsg").text("");
      $("#standardprice0ErrMsg").text("");
     }
    let indexFrom = $("#service0").val() === "" &&$("#standardprice0").val() === "" ? 1 : 0;
    miscCharges.forEach((row, index) => {
      if (index >= indexFrom) {
        validateField.push(
          { Id: `service${index}`, Type: "text" },
          {Id:`standardprice${index}`,Type:"text"});
      }
    });
    const validationResult = validateFields(validateField, true);
    validationResult.InValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text(t('ErrorMessage.RequiredMsg'));
    });
    validationResult.ValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("");
    });
    if (validationResult.IsValid === true && inValidComponent.length === 0) {
      return true;
    } else {
      return false;
    }
  }
 AddServiceDetails(){
  var arrayStroage = this.state.searchData.serviceDetails;
  var arrayLength = arrayStroage.length;
  if (arrayLength > 0) {
    let isValidMiscCharge = this.miscChargeValidation1();
    if (!isValidMiscCharge) {
      return;
    }
   this.state.searchData.serviceDetails = [
        ...this.state.searchData.serviceDetails,
        {
          id: arrayLength + 1,
          service:"",
          standardPrice:""
        },
      ]
      this.setState({})
  }
  
 }

 updateTermsData = (data) => {
  const { t } = this.props;
  let apiUrl = `${API.postBudgetList}`;
  axios({
    method: "POST",
    url: apiUrl,
    data: data,
  })
    .then((response) => {
      if (response?.status === 200) {
      }
    })
    .catch((error) => {
      // swal("Error!", "Something went wrong. Please try again.", "warning");
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('CommonText.500ErrorMessage'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
     // console.log("Error in Add settings Visitor" + error);
    });
};
  render() {
    const { t } = this.props;
    const {
      Budgetable,
      BudgetTableHistoryHead,
      BudgetTableHistoryBody,
      tomail,
      ccmail,
    } = this.state;
    return (
      <div className="pb-3">
        <Modal
          size="xl"
          show={this.state.modalIsOpen}
          onHide={() => {
            this.showModal(0, true);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("ComplianceandBudgetScreen.BudgetHistoryList")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-5 px-4">
            {Budgetable.length !== 0 ? (
              <>
                <div className="col-12 px-4 pt-2 mt-1">
                  <div
                    className={` table-responsive mb-5 ${
                      BudgetTableHistoryBody.length === 0
                        ? `tableNoHead`
                        : `tableFixHead`
                    }`}
                    style={{ width: "100%" }}
                  >
                    <div className="dataTables_wrapper no-footer">
                      <table className="table cellborder dataTable no-footer">
                        <thead>
                          <tr className="table-active section-color border">
                            <th
                              className={`${
                                window.innerWidth < 1000
                                  ? "border-left border-top border-bottom"
                                  : "sl-no"
                              } text-center align-middle border-right plan-color `}
                            >
                              {t("ComplianceandBudgetScreen.Sno")}
                            </th>
                            {BudgetTableHistoryHead.map((k, ind) => (
                              <th
                                className={`${
                                  window.innerWidth < 1000
                                    ? "border-left border-top border-bottom"
                                    : "sl-no"
                                } text-center align-middle border-right plan-color`}
                              >
                                {k}{" "}
                              </th>
                            ))}

                            <th
                              className={`${
                                window.innerWidth < 1000
                                  ? "border-left border-top border-bottom"
                                  : "sl-no"
                              } text-center align-middle border-right plan-color`}
                            >
                              {t("ComplianceandBudgetScreen.LastModifiedBy")}
                            </th>
                            <th
                              className={`${
                                window.innerWidth < 1000
                                  ? "border-left border-top border-bottom"
                                  : "sl-no"
                              } text-center align-middle border-right plan-color`}
                            >
                              {t("ComplianceandBudgetScreen.LastModifiedDate")}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="table-body">
                          {BudgetTableHistoryBody.length !== 0 ? (
                            BudgetTableHistoryBody.map((l, index) => (
                              <tr className="border-top">
                                <td className="text-center align-middle border-right border-left border-bottom border-top">
                                  {" "}
                                  <span className="spandoc-td">
                                    {index + 1}
                                  </span>
                                </td>
                                {BudgetTableHistoryHead.map((k, ind) => (
                                  <td className="text-center align-middle border-right border-bottom border-top">
                                    <span className="spandoc-td">
                                      {" "}
                                      {l?.filter(
                                        (item) => item?.zoneName === k
                                      )[0]?.price || "-"}{" "}
                                    </span>
                                  </td>
                                ))}
                                <td className="text-center align-middle border-right lastby-width border-bottom border-top">
                                  {" "}
                                  <span className="spandoc-td">
                                    {l[0]?.lastModifiedBy || "-"}
                                  </span>{" "}
                                </td>
                                <td className="text-center align-middle border-right lastdate-width border-bottom border-top">
                                  {" "}
                                  <span className="spandoc-td">
                                    {l[0]?.lastModifiedDate
                                      ? Moment(
                                          new Date(
                                            Date.parse(l[0]?.lastModifiedDate)
                                          )
                                        ).format("YYYY-MM-DD")
                                      : "-"}{" "}
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr className="border-top border-left border-bottom border-right">
                                <td
                                  colSpan={12}
                                  className="text-center align-middle plan-color border"
                                >
                                  <span className="spandoc-td">
                                    {" "}
                                    {t(
                                      "ComplianceandBudgetScreen.Nobudgethistorytodisplay"
                                    )}
                                  </span>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/*  <Paginator
               first={this.state.first}
               rows={pageSize}
               totalRecords={totalRecords}
               onPageChange={(e) => this.onPaginatorChange(e)}
             ></Paginator> */}
              </>
            ) : (
              <>
                <div
                  className="card"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div class="container">
                    <h6 className="resource-list-title no-item-card">
                      !--{" "}
                      {t("ComplianceandBudgetScreen.Nobudgethistorytodisplay")}
                      --!
                    </h6>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={this.state.contractmodalIsOpen}
          onHide={() => {
            this.showContractModal(0, true);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("ComplianceandBudgetScreen.InitiateContractDetails")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <div className="row">
                    <div className="col-lg-12">
                      <div className="initiate-style-contract">
                       <span className="pr-2"> {t("BudgetListOverview.DisplayEquipment")} </span>
                         <input type="checkbox" className="aadetails-checkbox" checked={this.state.searchData.mandatoryNC} onChange={(e) =>this.isNonContractApplicable(e)}></input>
                      </div>
                      </div>
            {this.state.searchData.mandatoryNC === true?
              <><div className="col-lg-12 px-5 px-4">
                      <label className="form-label fontstyle required">{t("BudgetListOverview.DescriptionDisplay")}</label>
                                  <br></br>
                                  <input
                                    type="text" className="form-control"
                                    value={this.state.searchData.mandatoryNCText}
                                    placeholder="Non Conract Text"
                                    onChange={(e) =>this.handleInputChangeText(e)}></input>
                                  <span id="noncontracttext"
                                  className="spanErrMsg ml-2"></span>
                                </div>
                               
                        
                </>
                    : null}
              </div>
            <div className="row pt-3">
              <div className="col-lg-12">
                <div className="mt-2" style={{ backgroundColor: "white" }}>
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}>
                    <h5
                      className="card-title ml-2 mt-2 f2"
                      style={{ color: "092a51" }}>
                      {t("BudgetListOverview.AAAServiceDetails")}{" "}
                    </h5>
                    <div
                      className="m-1 flex"
                      onClick={() => this.AddServiceDetails()}>
                      <span className="mt-1">
                        {t("ShipManagementContent.Add")}
                      </span>
                      <AddIcon />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="p-3 initiate-style">
                       <span className="pr-2"> {t("BudgetListOverview.IsVisible")} </span>
                         <input type="checkbox" className="aadetails-checkbox" checked={this.state.searchData.mandatoryToTSI} onChange={(e) =>this.isServiceApplicable(e)}></input>
                      </div>
                      </div>
                  </div>
                  {this.state.searchData.serviceDetails?.length !== 0
                    ? this.state.searchData.serviceDetails?.map(
                        (item, index) => {
                          return (
                            <>
                              <div className="row px-5 px-4 mt-2">
                                <div className="col-lg-6">
                                  <label className="form-label fontstyle">
                                    Service
                                  </label>
                                  <br></br>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="service"
                                    id={`service${index}`}
                                    value={item.service}
                                    placeholder="Service"
                                    onChange={(e) =>
                                      this.handleServiceDetailsInputChange(e,index)
                                    }
                                  ></input>
                                  <span id={`service${index}ErrMsg`}
                                  className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-6">
                                  <label className="form-label fontstyle">
                                    {t("BudgetListOverview.StandardPrice")}
                                  </label>
                                  <br></br>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="standardPrice"
                                    id={`standardprice${index}`}
                                    value={item.standardPrice}
                                    placeholder="Standard Price"
                                    onChange={(e) =>
                                      this.handleServiceDetailsInputChange(e,index)
                                    }
                                  ></input>
                                  <span id={`standardprice${index}ErrMsg`}
                                    className="spanErrMsg ml-2"></span>
                                </div>
                              </div>
                            </>
                          );
                        }
                      )
                    : null}
                </div>
              </div>
            </div>
            <div className="row pt-3">
              <div className="col-lg-12">
                <div className="mt-2" style={{ backgroundColor: "white" }}>
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}>
                    <h5
                      className="card-title ml-2 mt-2 f2"
                      style={{ color: "092a51" }}>
                      {t("BudgetListOverview.ContractApprovermails")}{" "}
                    </h5>
                 </div>
                 <div className="row px-5 px-4">
                  <div className="col-lg-6">
                <label className="form-label">
                  {" "}
                  {t("ComplianceandBudgetScreen.ApproverE-Mail")}
                </label>
                <br></br>
                <ReactMultiEmail
                  className="tomail"
                  emails={tomail}
                  onChange={(_emails) => {
                    this.setState({ tomail: _emails }, () => {
                    //  console.log("valu", $("div.tomail>input").val());
                    });
                  }}
                  getLabel={(email, index, removeEmail) => {
                    return (
                      <label
                        className="m-1"
                        key={index}
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: "14px",
                          wordBreak: "break-word",
                        }}
                      >
                        {email}
                        <span
                          style={{
                            fontSize: "20px",
                            verticalAlign: "middle",
                            marginLeft: ".25rem",
                          }}
                          data-tag-handle
                          name="delete"
                          onClick={() => removeEmail(index)}
                        >
                          &times;
                        </span>
                      </label>
                    );
                  }}
                />
              </div>
              <div className="col-lg-6">
                <label className="form-label">
                  {" "}
                  {t("ComplianceandBudgetScreen.CcMail")}
                </label>
                <br></br>
                <ReactMultiEmail
                  className="ccmail"
                  emails={ccmail}
                  onChange={(_emails) => {
                    this.setState({ ccmail: _emails });
                  }}
                  getLabel={(email, index, removeEmail) => {
                    return (
                      <label
                        className="m-1"
                        key={index}
                        style={{
                          backgroundColor: "lightgray",
                          fontSize: "14px",
                          wordBreak: "break-word",
                        }}
                      >
                        {email}
                        <span
                          style={{
                            fontSize: "20px",
                            verticalAlign: "middle",
                            marginLeft: ".25rem",
                          }}
                          data-tag-handle
                          name="delete"
                          onClick={() => removeEmail(index)}
                        >
                          &times;
                        </span>
                      </label>
                    );
                  }}
                />
              </div>
              </div>
                </div>
              </div>
            </div>
                  
            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}>
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.postBudegetList()}>
                {t("ComplianceandBudgetScreen.Submit")}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showContractModal(0, true)}
              >
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          size="xl"
          id="myModal"
          show={this.state.termsmodalIsOpen}
          onHide={() => {
            this.showEditTermsModal(false);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("BudgetListOverview.EditTermsCondition")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-5 px-4">
            <div className="row">
              <div className="col-12">
           <div className="pt-2" id="summernote"></div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="mt-2" style={{ backgroundColor: "white" }}>
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2 f2"
                      style={{ color: "092a51" }}
                    >
                      {t("BudgetListOverview.AddDynamicLabels")}{" "}
                    </h5>
                    <div
                      className="m-1 flex"
                      onClick={() => this.AddNewLabel()}
                    >
                      <span className="mt-1">
                        {t("ShipManagementContent.Add")}
                      </span>
                      <AddIcon />
                    </div>
                  </div>
                  {this.state.AddDynamicLabel?.length !== 0
                    ? this.state.AddDynamicLabel.map((x, index) => {
                        return (
                          <>
                            <div className="row termlabel">
                              <div className="col-lg-3 p-2">{t("BudgetListOverview.EnterLabelName")} :</div>
                              <div className="col-lg-4">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="labelName"
                                  id={`chargeDescription${index}`}
                                  value={x.labelName}
                                  placeholder="label name"
                                  onChange={(e) =>this.handleLabelInputChange(e, index)}></input>
                                <span
                                  id={`chargeDescription${index}ErrMsg`}
                                  className="spanErrMsg ml-2"
                                ></span>
                              </div>
                              <div className="col-lg-1"></div>
                              <div className="col-lg-2 p-2">
                                <span> {t("BudgetListOverview.IsMandatory")} </span>
                                <input type="checkbox" style={{float: "right",height: "17px",width: "17px",marginTop:"5PX"}}
                                 name="isMandatory"
                                onChange={(e) =>this.handleLabelMandatorySelect(e,index)} ></input>
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>

            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.submitTermsCondition()}
              >
                {t("ComplianceandBudgetScreen.Submit")}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showEditTermsModal(false)}
              >
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={this.state.serviceprovidermodalIsOpen}
          onHide={() => {
            this.SubmitContract("model");
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("BudgetListOverview.ComplianceDetails")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-x px-4">
            <div className="row">
              <div className="col-lg-4">
                <label className="form-label fontstyle required">{t("EquipmentManagementScreenContent.Name")}</label>
                <br></br>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={this.state.ServiceProviderInfo.name}
                  placeholder="Name"
                  onChange={(e) => this.handleServiceInputChange(e)}
                ></input>
                <span id="NameErrMsg" className="spanErrMsg ml-2"></span>
              </div>
              <div className="col-lg-4">
                <label className="form-label fontstyle required"> {t("DashboardShipReports.Date")} </label>
                <br></br>
                <div
                  className="input-group add-on date datepicker"
                  data-date-format="yyyy-mm-dd"
                >
                  <input
                    type="text"
                    className="form-control date-picker"
                    placeholder="Date"
                    id="Date"
                    value={this.state.ServiceProviderInfo.date}
                  ></input>
                  <DatePicker
                    showMonthDropdown
                    showYearDropdown
                    onChange={this.handleDateofBuild}
                    open={this.state.ServiceDatePickerIsOpen}
                    onClickOutside={this.handleBlur}
                    dropdownMode="select"
                    popperPlacement="right-start"
                    className="form-control date-picker w-5 hide-date"
                  />
                  <div
                    className="input-group-btn calendar-icon"
                    onClick={this.openDatePicker}
                  >
                    <button
                      className="btn btn-default"
                      style={{ height: "100%" }}
                    >
                      <i className="fa fa-calendar mt-1"></i>
                    </button>
                  </div>
                </div>
                <span id="DateErrMsg" className="spanErrMsg ml-2"></span>
              </div>
              { this.state.isWorldWide.length !==0 ? (this.state.isWorldWide[0].filter((item, index) =>item.zoneName === "Worldwide").length === 1 ? null : (
              <div className="col-lg-4">
                <label className="form-label fontstyle required">
                {t("BudgetListOverview.WorldwidePrice")}
                </label>
                <br></br>
                <input
                  type="text"
                  className="form-control"
                  name="worldwide"
                  value={this.state.ServiceProviderInfo.worldwide}
                  placeholder="Worldwide"
                  onChange={(e) => this.handleServiceInputChange(e)}
                ></input>
                <span id="WorldwideErrMsg" className="spanErrMsg ml-2"></span>
              </div>)):null}
              {/* <div className="col-lg-6">
                <label className="form-label fontstyle required">
                  Appendix Image
                </label>
                <br></br>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      Browse File
                      <input
                        type="file"
                        id="files"
                        title=" "
                        accept=".png,.jpg,jpeg"
                        style={{ marginRight: 40 }}
                        onChange={(e) => this.handleInputFileChange(e)}
                        onClick={(event) => {
                          event.currentTarget.value = null;
                        }}
                      />
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder=""
                    name="username"
                    value={this.state.ServiceProviderInfo.appendixName}
                  />
                  {this.state.ServiceProviderInfo.appendixName ? (
                    <div
                      class="input-group-append"
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        class="fa fa-times input-group-text"
                        aria-hidden="true"
                        onClick={() => this.ClearInput()}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <span id="LogoErrMsg" className="spanErrMsg"></span>
              </div>
              <div className="col-12 col-sm-12  col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center">
                {this.state.AppendixFile && this.state.AppendixFile !== "" ? (
                  <>
                    <div className="row align-items-center">
                      <div
                        className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center"
                        style={{
                          display: "flex",
                          marginTop: "35px",
                        }}
                      >
                        <div className="ml-2">
                          <img
                            src={this.state.AppendixFile}
                            className="cursorPointer"
                            style={{
                              width: "75px",
                              height: "45px",
                              marginTop: "-12px",
                            }}
                          />
                        </div>
                        <div
                          className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4"
                          style={{
                            fontSize: "10px",
                            marginTop: "-15px",
                          }}
                        >
                          <div className="px-2 overflow cursorPointer">
                            {this.state.ServiceProviderInfo.appendixName}
                          </div>
                        </div>
                        <div className="" style={{ marginTop: "-16px" }}>
                          <i
                            className="fa fa-trash click m-1"
                            onClick={() => {
                              this.OpenPopup("Logo");
                            }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div> */}
              <div className="col-lg-6">
                <label className="form-label fontstyle required">
                {t("ComplianceandBudgetScreen.Signature")}
                </label>
                <br></br>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      {t("ServiceDetails.BrowseFile")}
                      <input
                        type="file"
                        id="files"
                        title=" "
                        accept=".png,.jpg,jpeg"
                        style={{ marginRight: 40 }}
                        onChange={(e) => this.handleInputFileChange1(e)}
                        onClick={(event) => {
                          event.currentTarget.value = null;
                        }}
                      />
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder=""
                    name="username"
                    value={this.state.ServiceProviderInfo.signatureName}
                  />
                  {this.state.ServiceProviderInfo.signatureName ? (
                    <div
                      class="input-group-append"
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        class="fa fa-times input-group-text padding-top-9px"
                        aria-hidden="true"
                        onClick={() => this.ClearInput1()}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <span id="SignatureErrMsg" className="spanErrMsg"></span>
              </div>
              <div className="col-12 col-sm-12  col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center">
                {this.state.SignatureFile && this.state.SignatureFile !== "" ? (
                  <>
                    <div className="row align-items-center">
                      <div
                        className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center"
                        style={{
                          display: "flex",
                          marginTop: "35px",
                        }}
                      >
                        <div className="ml-2">
                          <img
                            src={this.state.SignatureFile}
                            className="cursorPointer"
                            style={{
                              width: "75px",
                              height: "45px",
                              marginTop: "-12px",
                            }}
                          />
                        </div>
                        <div
                          className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4"
                          style={{
                            fontSize: "10px",
                            marginTop: "-15px",
                          }}
                        >
                          <div className="px-2 overflow cursorPointer text-break">
                            {this.state.ServiceProviderInfo.signatureName}
                          </div>
                        </div>
                        <div className="" style={{ marginTop: "-16px" }}>
                          <i
                            className="fa fa-trash click m-1"
                            onClick={() => {
                              this.OpenPopup("Signature");
                            }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
         
            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.SubmitContractDetails()}
              >
                {t("ComplianceandBudgetScreen.Submit")}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.SubmitContract("model")}
              >
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={this.state.selectZoneModalIsOpen}
          onHide={() => {
            this.showSelectZoneModal(0, true);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("BudgetListOverview.AddZoneDescription")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-5 px-4">
            <div className="row">
              <div className="col-lg-12">
                <label className="form-label">
                  {" "}
                  {t("BudgetListOverview.EntertheDescriptionFor")} {this.state.NewDescription ? this.state.NewDescription[0]?.zoneName:""}
                </label>
                <br></br>
                <input
                  type="text"
                  name="description"
                  placeholder="Enter Description"
                  className="form-control px-2"
                  value={this.state.NewDescription? this.state.NewDescription[0]?.description:""}
                  onChange={(e) => this.handleDescriptionInputChange(e,this.state.NewDescription)}
                 />
           </div>
          
            </div>
            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={()=>this.closeDescriptionmodel()}>
                {t("ShipManagementContent.Add")}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showSelectZoneModal(0, true)}
              >
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const {
      mmplHistorySearchResult,
      applicableServiceType,
      EquipmentZoneList,
      shipDetail,
      zoneList,
      ContractPanelDetails,
      t,
      match
    } = this.props;
    const {
      Budgetable,
      Compliancetable,
      NonContractTable,
      NonContractApplicableYears,
      isWorldWide,
      ComplianceApplicableYears,
    } = this.state;
    //  console.log("zone");
    var ServeData = EquipmentZoneList;
    // console.log("serve", ServeData);

    $("#example").DataTable({
      bPaginate: false,
      bFilter: false,
      bInfo: false,
      dataType: "JSON",
      data: ServeData,
      order: [[2, "desc"]],
      language: {
        zeroRecords:
          '<center><span style="color:#1a3464;font-weight: 700;font-size: 22px;">No Item to Display</span></center>',
      },
      bDestroy: true,
    });

    $("#example1").DataTable({
      bPaginate: false,
      bFilter: false,
      bInfo: false,
      dataType: "JSON",
      data: ServeData,
      columns: [{ data: "Zone A" }, { data: "Zone B" }, { data: "Zone C" }],
      language: {
        zeroRecords:
          '<center><span style="color:#1a3464;font-weight: 700;font-size: 22px;">No Item to Display</span></center>',
      },
      bDestroy: true,
    });
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
              onClick={() => this.hideSidePanel()}
              style={{display:'inline-flex',alignItems:'center'}}
            >
              <span style={{marginTop:'-1px'}}>&larr;</span> {t("CommonText.Back")}
            </button>
            <div className="col-lg-12 mt-1">
              <div className="row resource-list-auth-date">
                <div className="col-lg-12">
                  <div className="panel-box search-filter-box">
                    <span className="mt-1">
                      <strong style={{ fontSize: "larger" }}>
                        {t("content.Shipname")} :{" "}
                      </strong>
                      <span className="lato">
                        {shipDetail.shipName ? shipDetail.shipName : ""}
                      </span>
                    </span>

                    <div
                      className="card MM-card-header mb-0 mt-3"
                      style={{ backgroundColor: "white" }}>
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}>
                          {match.path==="/Home/ContractListEdit/:id"?
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}>
                         {t("content.ContractList")}
                        </h5>:<h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}>
                         {t("content.BudgetListScreen")}
                        </h5>}

                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row px-4">
                        <div className="col-12 px-4 pt-2 mt-1">
                          <div
                            className="table-responsive"
                            style={{ width: "100%" }}>
                            <table className="table border-top border-bottom border-left border-right">
                              <thead>
                                <tr className="table-active section-color border">
                                  <th className={`border-right border-left equipment-width plan-color`}>
                                    {" "}
                                    {t("ComplianceandBudgetScreen.Equipments")}
                                    {match.path==="/Home/BudgetListEdit/:id"?
                                    <>
                                    <i class={`fa fa-filter click ml-2 cursor-pointer text-right showhideicon filter-style ${this.state.isFilterApply? "filterApplyColor":" "}`}  id="popover"></i>
                                 <Popover 
                             placement="right"
                             className="popover-equip"
                             trigger="legacy"
                             isOpen={this.state.popover}
                             target={"popover"}
                             toggle={() => this.toggle(`popover`)}>
                            <PopoverHeader>
                            {t("BudgetListOverview.ContractEquipmentSearch")}
                            </PopoverHeader>
                            <PopoverBody>
                              <div className="row">
                                <div className="col-6 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style"
                                    checked={this.state.isContract}
                                    onChange={(e) =>this.handleEquipmentCotractChange(e)} />
                                  <span className="ml-2" style={{marginTop:"2px"}}>{t("ContractContent.IsContract")}</span>
                                </div>
                                <div className="col-6 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style-shore"
                                    checked={this.state.isNotContract}
                                    onChange={(e) =>
                                      this.handleNotEquipmentContractChange(e)
                                    }/>
                                  <span className="ml-1" style={{marginTop:"2px"}}>{t("ContractContent.NotContract")}</span>
                                </div>
                          
                                </div>
                            </PopoverBody>
                                  </Popover></>:<></>}
                                  </th>
                                  <th className="border-right border-left type-width plan-color">
                                    {t("ComplianceandBudgetScreen.Qty")}{" "}
                                  </th>
                                  <th
                                    className="border-right border-left type-width plan-color"
                                    scope="col"
                                  >
                                    {t("ComplianceandBudgetScreen.Type")}{" "}
                                  </th>
                                  {ComplianceApplicableYears?.map(
                                    (i, index) => (
                                      <th
                                        className="border-right border-left year-width plan-color"
                                        scope="col"
                                      >
                                        {i}
                                      </th>
                                    )
                                  )}
                                  <th
                                    className="border-right border-left remark-width plan-color"
                                    scope="col"
                                  >
                                    {t("DashboardShipReports.Remarks")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="table-body">
                                {Compliancetable?.equipments?.length !==0 ? (
                                  Compliancetable?.equipments?.map(
                                    (j, index) => (
                                      <>
                                        <tr className="border-top">
                                          <td
                                            className="border-right text-center align-middle"
                                            rowSpan={2}>
                                              { match.path==="/Home/BudgetListEdit/:id"?
                                           <span className={`spandoc-td ${j?.inContract===true?"ContractColor":""}`}>
                                            {j.equipmentName}
                                          </span>
                                            : <span className="spandoc-td">  {j.equipmentName}</span>}
                                          </td>
                                          <td
                                            className="border-right text-center align-middle type-width"
                                            rowSpan={2}>
                                            {" "}
                                            <span className="spandoc-td">
                                              {j.quantity}
                                            </span>
                                          </td>
                                          <td className="border-right text-center align-middle type-width">
                                            <span className="spandoc-td">
                                              {t(
                                                "Generateservicerequestcontent.Ship"
                                              )}
                                            </span>
                                          </td>
                                          {ComplianceApplicableYears?.map(
                                            (i, index) => (
                                              <td className="border-right click year-width">
                                                {" "}
                                                {j.shipServiceYears.filter(
                                                  (item) => item === i
                                                )[0] ? (
                                                  <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400,
                                                    }}
                                                    overlay={this.renderPopoverTick(
                                                      j.shipServiceYears.filter(
                                                        (item) => item === i
                                                      )[0],
                                                      j,
                                                      "ship"
                                                    )} >
                                                    <i
                                                      class="fa fa-check checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </OverlayTrigger>
                                                ) : (
                                                  <>
                                                    <i
                                                      class="fa fa-times checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {userrole ==
                                                      Role.mmpladmin ||
                                                    (userrole ==
                                                      Role.approver &&
                                                      shipDetail.status ===
                                                        "Approverapprovalpending") ? (
                                                      <input
                                                        type="checkbox"
                                                        className="checkbox-hover checkboxesship"
                                                        name="isAdmin"
                                                        id={`isShip${
                                                          j.shipServiceYears.filter(
                                                            (item) => item === i
                                                          )[0]
                                                        }`}
                                                        onChange={(e) =>
                                                          this.handleCheckboxInputChange(
                                                            e,
                                                            i,
                                                            j.shipServiceYears.filter(
                                                              (item) =>
                                                                item === i
                                                            )[0],
                                                            j,
                                                            "ship"
                                                          )
                                                        }
                                                      ></input>
                                                    ) : null}
                                                  </>
                                                )}
                                              </td>
                                            )
                                          )}
                                          <td
                                            className="commentsrequire-td2 align-middle"
                                            rowSpan={2}
                                          >
                                            <span className="spandoc-td">
                                              {userrole == Role.mmpladmin ||
                                              (userrole == Role.approver &&
                                                shipDetail.status ===
                                                  "Approverapprovalpending") ? (
                                                <CssTextField
                                                  multiline
                                                  fullWidth
                                                  variant="outlined"
                                                  type="text"
                                                  onChange={(e) =>
                                                    this.handleInputChange(e, j)
                                                  }
                                                  onBlur={(e) =>
                                                    this.UpdateRemarks(e, j)
                                                  }
                                                  value={j?.remarks}
                                                  InputProps={{
                                                    className: `border-radius padding-space`,
                                                  }}
                                                />
                                              ) : (
                                                <span>{j?.remarks}</span>
                                              )}
                                            </span>
                                          </td>
                                        </tr>

                                        <tr className="border-top">
                                          <td className="border-right text-center align-middle type-width">
                                            <span className="spandoc-td">
                                              {t(
                                                "Generateservicerequestcontent.Shore"
                                              )}
                                            </span>
                                          </td>
                                          {ComplianceApplicableYears?.map(
                                            (i, index) => (
                                              <td className="border-right click">
                                                {" "}
                                                {j.shoreServiceYears.filter(
                                                  (item) => item === i
                                                )[0] ? (
                                                  <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400,
                                                    }}
                                                    overlay={this.renderPopoverTickShore(
                                                      j.shoreServiceYears.filter(
                                                        (item) => item === i
                                                      )[0],
                                                      j,
                                                      "shore"
                                                    )}
                                                  >
                                                    <i
                                                      class="fa fa-check checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </OverlayTrigger>
                                                ) : (
                                                  <>
                                                    <i
                                                      class="fa fa-times checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {userrole ==
                                                      Role.mmpladmin ||
                                                    (userrole ==
                                                      Role.approver &&
                                                      shipDetail.status ===
                                                        "Approverapprovalpending") ? (
                                                      <input
                                                        type="checkbox"
                                                        className="checkbox-hover checkboxesship"
                                                        id={`isShore${
                                                          j.shoreServiceYears.filter(
                                                            (item) => item === i
                                                          )[0]
                                                        }`}
                                                        onChange={(e) =>
                                                          this.handleCheckboxInputChange(
                                                            e,
                                                            i,
                                                            j.shoreServiceYears.filter(
                                                              (item) =>
                                                                item === i
                                                            )[0],
                                                            j,
                                                            "shore"
                                                          )
                                                        }
                                                      ></input>
                                                    ) : null}
                                                  </>
                                                )}
                                              </td>
                                            )
                                          )}
                                        </tr>
                                      </>
                                    )
                                  )
                                ) : (
                                  <>
                                    <tr className="border-top">
                                      <td
                                        colSpan={11}
                                        className="text-center align-middle"
                                      >
                                        <span className="spandoc-td">
                                          {" "}
                                          {t(
                                            "ComplianceandBudgetScreen.Nocompliancetodisplay"
                                          )}
                                        </span>
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    {match.path==="/Home/BudgetListEdit/:id"?<></>:
                    <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <Accordion>
                <Card
                  className={"MM-card-header"}
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Toggle
                    as={Card.Body}
                    eventKey="0"
                    style={{ cursor: "pointer" }}
                    onClick={this.contractToggleVisibility}>
                    <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}>
                   {!this.state.isNonContractVisible ? (
                        <i
                          className="fa fa-plus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-minus mr-1"
                          aria-hidden="true"
                          style={{ color: "#fff", fontSize: "1.1rem" }}
                        ></i>
                      )}{" "}
                     {t("ContractContent.NonContractPending")}
                    </h5>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="search-filter-box history-box mt-2">
                    <div className="row my-2">
                    <div className="col-12 px-4 pt-2 mt-1">
                          <div
                            className="table-responsive"
                            style={{ width: "100%" }}>
                            <table className="table border-top border-bottom border-left border-right">
                              <thead>
                                <tr className="table-active section-color border">
                                  <th className={`border-right border-left equipment-width plan-color`}>
                                    {" "}
                                    {t("ComplianceandBudgetScreen.Equipments")}
                                   
                                  </th>
                                  <th className="border-right border-left type-width plan-color">
                                    {t("ComplianceandBudgetScreen.Qty")}{" "}
                                  </th>
                                  <th
                                    className="border-right border-left type-width plan-color"
                                    scope="col"
                                  >
                                    {t("ComplianceandBudgetScreen.Type")}{" "}
                                  </th>
                                  {NonContractApplicableYears?.map(
                                    (i, index) => (
                                      <th
                                        className="border-right border-left year-width plan-color"
                                        scope="col"
                                      >
                                        {i}
                                      </th>
                                    )
                                  )}
                                  <th
                                    className="border-right border-left remark-width plan-color"
                                    scope="col"
                                  >
                                    {t("DashboardShipReports.Remarks")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="table-body">
                                {NonContractTable?.equipments?.length !==0 ? (
                                  NonContractTable?.equipments?.map(
                                    (k, index) => (
                                      <>
                                        <tr className="border-top">
                                          <td
                                            className="border-right text-center align-middle"
                                            rowSpan={2}>
                                              
                                    <span className="spandoc-td">  {k.equipmentName}</span>
                                          </td>
                                          <td
                                            className="border-right text-center align-middle type-width"
                                            rowSpan={2}>
                                            {" "}
                                            <span className="spandoc-td">
                                              {k.quantity}
                                            </span>
                                          </td>
                                          <td className="border-right text-center align-middle type-width">
                                            <span className="spandoc-td">
                                              {t(
                                                "Generateservicerequestcontent.Ship"
                                              )}
                                            </span>
                                          </td>
                                          {NonContractApplicableYears?.map(
                                            (i, index) => (
                                              <td className="border-right click year-width">
                                                {" "}
                                                {k.shipServiceYears.filter(
                                                  (item) => item === i
                                                )[0] ? (
                                                  <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400,
                                                    }}
                                                    overlay={this.renderPopoverTick(
                                                      k.shipServiceYears.filter(
                                                        (item) => item === i
                                                      )[0],
                                                      k,
                                                      "ship"
                                                    )} >
                                                    <i
                                                      class="fa fa-check checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </OverlayTrigger>
                                                ) : (
                                                  <>
                                                    <i
                                                      class="fa fa-times checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {userrole ==
                                                      Role.mmpladmin ||
                                                    (userrole ==
                                                      Role.approver &&
                                                      shipDetail.status ===
                                                        "Approverapprovalpending") ? (
                                                      <input
                                                        type="checkbox"
                                                        className="checkbox-hover checkboxesship"
                                                        name="isAdmin"
                                                        id={`isShip${
                                                          k.shipServiceYears.filter(
                                                            (item) => item === i
                                                          )[0]
                                                        }`}
                                                        onChange={(e) =>
                                                          this.handleContractCheckboxInputChange(
                                                            e,
                                                            i,
                                                            k.shipServiceYears.filter(
                                                              (item) =>
                                                                item === i
                                                            )[0],
                                                            k,
                                                            "ship"
                                                          )
                                                        }
                                                      ></input>
                                                    ) : null}
                                                  </>
                                                )}
                                              </td>
                                            )
                                          )}
                                          <td
                                            className="commentsrequire-td2 align-middle"
                                            rowSpan={2}>
                                            <span className="spandoc-td">
                                              {userrole == Role.mmpladmin ||
                                              (userrole == Role.approver && shipDetail.status ==="Approverapprovalpending") ? (
                                                <CssTextField
                                                  multiline
                                                  fullWidth
                                                  id={"noncontract" + index}
                                                  style={{height: $("#noncontract" + index).outerHeight() }}
                                                  variant="outlined"
                                                  type="text"
                                                  onChange={(e) =>
                                                    this.handleNonContractInputChange(e, k)
                                                  }
                                                  onBlur={(e) =>
                                                    this.UpdateNonContractRemarks(e, k)
                                                  }
                                                  value={k?.remarks}
                                                  InputProps={{
                                                    className: `border-radius padding-space`,
                                                  }}
                                                />
                                              ) : (
                                                <span>{k?.remarks}</span>
                                              )}
                                            </span>
                                          </td>
                                        </tr>

                                        <tr className="border-top">
                                          <td className="border-right text-center align-middle type-width">
                                            <span className="spandoc-td">
                                              {t(
                                                "Generateservicerequestcontent.Shore"
                                              )}
                                            </span>
                                          </td>
                                          {NonContractApplicableYears?.map(
                                            (i, index) => (
                                              <td className="border-right click">
                                                {" "}
                                                {k.shoreServiceYears.filter(
                                                  (item) => item === i
                                                )[0] ? (
                                                  <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400,
                                                    }}
                                                    overlay={this.renderPopoverTickShore(
                                                      k.shoreServiceYears.filter(
                                                        (item) => item === i
                                                      )[0],
                                                      k,
                                                      "shore"
                                                    )}
                                                  >
                                                    <i
                                                      class="fa fa-check checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </OverlayTrigger>
                                                ) : (
                                                  <>
                                                    <i
                                                      class="fa fa-times checkbox-style"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {userrole ==
                                                      Role.mmpladmin ||
                                                    (userrole ==
                                                      Role.approver &&
                                                      shipDetail.status ===
                                                        "Approverapprovalpending") ? (
                                                      <input
                                                        type="checkbox"
                                                        className="checkbox-hover checkboxesship"
                                                        id={`isShore${
                                                          k.shoreServiceYears.filter(
                                                            (item) => item === i
                                                          )[0]
                                                        }`}
                                                        onChange={(e) =>
                                                          this.handleContractCheckboxInputChange(
                                                            e,
                                                            i,
                                                            k.shoreServiceYears.filter(
                                                              (item) =>
                                                                item === i
                                                            )[0],
                                                            k,
                                                            "shore"
                                                          )
                                                        }
                                                      ></input>
                                                    ) : null}
                                                  </>
                                                )}
                                              </td>
                                            )
                                          )}
                                        </tr>
                                      </>
                                    )
                                  )
                                ) : (
                                  <>
                                    <tr className="border-top">
                                      <td
                                        colSpan={11}
                                        className="text-center align-middle"
                                      >
                                        <span className="spandoc-td">
                                          {" "}
                                          {t(
                                            "ComplianceandBudgetScreen.Nocompliancetodisplay"
                                          )}
                                        </span>
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                     </div>
                    </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
                    </div>}
                    {userrole == Role.mmpladmin ||
                    (userrole == Role.approver &&
                      shipDetail.status === "Approverapprovalpending") ? (
                      <div className="search-filter-box px-0">
                        <div
                          className="card MM-card-header mb-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className="card-body"
                            style={{
                              padding: "0rem",
                              backgroundColor: "#1a3464",
                              color: "white",
                            }}
                          >
                            <h5
                              className="card-title ml-2 mt-2"
                              style={{ color: "092a51" }}
                            >
                              {" "}
                              {t("ComplianceandBudgetScreen.BudgetList")}
                            </h5>
                          </div>
                        </div>
                        <div className="row px-5">
                          <div className="col-lg-11 col-10">
                            <div
                              className="table-responsive mt-3"
                              style={{ width: "100%" }}
                            >
                              {this.state.isNewBudget ? (
                                <table
                                  id="Docstable example1"
                                  className="table  border-top border-bottom border-left border-right"
                                >
                                  <thead>
                                    <tr className="border-top section-color spandoc-thead">
                                      <th
                                        className="text-center border-right border-left align-middle"
                                        scope="col"
                                      >
                                        <select
                                          className="form-control"
                                          name="ZoneName"
                                          id="Zone"
                                          value={this.state.AddBudget.ZoneName}
                                          onChange={(e) =>
                                            this.handleZoneChange(e)
                                          }
                                        >
                                          <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                                          {zoneList &&
                                            zoneList?.map((zonename) => (
                                              <option value={zonename.value}>
                                                {zonename.value}
                                              </option>
                                            ))}
                                        </select>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="table-body">
                                    <tr className="border-top">
                                      <td className="commentsrequire-td2 align-middle border-right">
                                        <span className="spandoc-td">
                                          <CssTextField
                                            multiline
                                            fullWidth
                                            variant="outlined"
                                            type="text"
                                            onChange={(e) =>
                                              this.handleInputChangeNewBudget(e)
                                            }
                                            onBlur={(e) =>
                                              this.UpdateNewBudget(e)
                                            }
                                            value={
                                              this.state.AddBudget.ZoneValue
                                            }
                                            InputProps={{
                                              className: `border-radius padding-space`,
                                            }}
                                          />
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              ) : null}

                              {Budgetable.length !== 0 ? (
                              <>  <table
                                  id="Docstable example1"
                                  className="table  border-top border-bottom border-left border-right">
                                  <thead>
                                    <tr className="border-top section-color spandoc-thead">
                                      {Budgetable.filter(
                                        (item, index) =>
                                          index === Budgetable.length - 1
                                      ).map((k, ind) =>
                                        k.map((i, index) => (
                                        (shipDetail.status === "Initiatecontractpending" &&!ContractPanelDetails?.response) ||
                                          (shipDetail.status === "Initiatecontractpending" && ContractPanelDetails?.response === "rejected")?
                                          <th
                                            className="text-center border-right border-left align-middle"
                                            scope="col" >
                                              {this.state.selectedZone.length >0?
                                              <span className="zoneselect" onClick={()=>this.showSelectZoneModal(0, false,i)}>{i.zoneName}{" "}({t("BudgetListOverview.USD")}){""}</span>:
                                              <span>{i.zoneName}{" "} ({t("BudgetListOverview.USD")}){" "}</span>}
                                            {""}<input
                                                type="checkbox"
                                                style={{
                                                  float: "right",
                                                  height: "17px",
                                                  width: "17px",
                                                }}
                                                onChange={(e) =>
                                                  this.handleCheckboxInputZoneSelect(e,i)}
                                              ></input> </th>: <th
                                              className="text-center border-right border-left align-middle"
                                              scope="col">
                                              {i.zoneName}{""} (USD){" "}</th>
                                         
                                        ))
                                      )}

                                      {this.state.isWorldwideBudget ? (
                                        <th
                                          className="text-center border-right border-left align-middle"
                                          scope="col"
                                        >
                                          {t("BudgetListOverview.WorldWide")}
                                        </th>
                                      ) : null}
                                    </tr>
                                  </thead>
                                  <tbody className="table-body">
                                    <tr className="border-top">
                                      {Budgetable.filter(
                                        (item, index) =>
                                          index === Budgetable.length - 1
                                      ).map((k, ind) =>
                                        k.map((i, index) =>
                                          this.state.isDuplicate ? (
                                            <td className="commentsrequire-td2 align-middle border-right">
                                              <span className="spandoc-td">
                                                <CssTextField
                                                  multiline
                                                  fullWidth
                                                  variant="outlined"
                                                  type="text"
                                                  onChange={(e) =>
                                                    this.handleInputChange1(
                                                      e,
                                                      i
                                                    )
                                                  }
                                                  onBlur={(e) =>
                                                    this.UpdateBudget(e, i)
                                                  }
                                                  value={i?.price}
                                                  InputProps={{
                                                    className: `border-radius padding-space`,
                                                  }}
                                                />
                                              </span>
                                            </td>
                                          ) : (
                                            <td className="text-center align-middle border-right">
                                              <span className="spandoc-td">
                                                {" "}
                                                {i.price}
                                              </span>
                                            </td>
                                          )
                                        )
                                      )}

                                      {this.state.isWorldwideBudget ? (
                                        <td className="commentsrequire-td2 align-middle border-right">
                                          <span className="spandoc-td">
                                            <CssTextField
                                              multiline
                                              fullWidth
                                              variant="outlined"
                                              type="text"
                                              onChange={(e) =>
                                                this.handleInputChangeWorld(
                                                  e,
                                                  isWorldWide[0][0]
                                                )
                                              }
                                              onBlur={(e) =>
                                                this.UpdateBudgetworld(
                                                  e,
                                                  isWorldWide[0][0]
                                                )
                                              }
                                              value={this.state.worldwidevalue}
                                              InputProps={{
                                                className: `border-radius padding-space`,
                                              }}
                                            />
                                          </span>
                                        </td>
                                      ) : null}
                                    </tr>
                                  </tbody>
                                </table>
                                 {(shipDetail.status === "Initiatecontractpending" &&!ContractPanelDetails?.response) ||
                                  (ContractPanelDetails?.response === "pending" &&shipDetail.status == "Clientapprovalpending") ||
                                  (shipDetail.status === "Initiatecontractpending" && ContractPanelDetails?.response === "rejected")?
                                <span className={`${
                                        this.state.isSelectZone
                                          ? "spanColor"
                                          : "newspanErrMsg"
                                      } ml-2`}
                                    >
                                      {" "}
                                      {t("BudgetListOverview.NotePleaseselect")}
                                    </span>:<></>}
                                 </>
                              ) : (
                                <>
                                  {!this.state.isNewBudget ? (
                                    <div
                                      className="card"
                                      style={{
                                        overflow: "hidden",
                                        position: "relative",
                                      }}
                                    >
                                      <div class="container">
                                        <h6 className="resource-list-title no-item-card">
                                          !--
                                          {t(
                                            "ComplianceandBudgetScreen.NoBudgettodisplay"
                                          )}
                                          --!
                                        </h6>
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>
                          {Budgetable.length === 0 ? (
                            <>
                              <div
                                className="col-lg-1 col-2 px-0 text-center"
                                style={{
                                  marginTop: `${
                                    this.state.break ? "32px" : "43px"
                                  }`,
                                }}
                              >
                                <div
                                  className="ml0"
                                  style={{ marginLeft: "-17px" }}
                                >
                                  <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={this.renderAddnewbudget()}
                                  >
                                    <MdAddBox
                                      className="px-1 click"
                                      style={{
                                        color: "#1a3464",
                                        fontSize: "2.4rem",
                                        marginTop: `${
                                          this.state.break ? "0px" : "-35px"
                                        }`,
                                        marginLeft: `${
                                          this.state.break ? "-4px" : "0px"
                                        }`,
                                      }}
                                      onClick={() => this.AddNewBudget()}
                                    />
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </>
                          ) : null}

                          {Budgetable[0]?.length !== 0 ? (
                            Budgetable.filter(
                              (item, index) => index === Budgetable.length - 1
                            )[0] ? (
                              <>
                                <div
                                  className="col-lg-1 col-2 px-0 text-center"
                                  style={{
                                    marginTop: `${
                                      this.state.break ? "32px" : "43px"
                                    }`,
                                  }}>
                                  <div
                                    className="ml0"
                                    style={{ marginLeft: "-17px" }}
                                  >
                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{
                                        show: 250,
                                        hide: 400,
                                      }}
                                      overlay={this.renderPopover()}
                                    >
                                      <i
                                        className={`fa fa-edit click ${
                                          this.state.isDuplicate
                                            ? `editicon`
                                            : ``}`}
                                        aria-hidden="true"
                                        onClick={() => this.openDuplicate()}
                                        style={{
                                          color: " #1a3464",
                                          fontSize: "2em",
                                          color: `${
                                            this.state.isDuplicate
                                              ? "grey"
                                              : "#1a3464"
                                          }`,
                                        }}
                                      ></i>
                                    </OverlayTrigger>
                                    {isWorldWide[0].filter(
                                      (item, index) =>
                                        item.zoneName === "Worldwide"
                                    ).length === 1 ? null : (
                                      <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={this.rendernewbudget()}
                                      >
                                        <MdAddBox
                                          className="px-1 click"
                                          style={{
                                            color: `${
                                              this.state.isWorldwideBudget
                                                ? "grey"
                                                : "#1a3464"
                                            }`,
                                            pointerEvents: `${
                                              this.state.isWorldwideBudget
                                                ? "none"
                                                : "block"
                                            }`,
                                            fontSize: "2.4rem",
                                            marginTop: `${
                                              this.state.break ? "0px" : "-14px"
                                            }`,
                                            marginLeft: `${
                                              this.state.break ? "-4px" : "0px"
                                            }`,
                                          }}
                                          onClick={() => this.openBudget()}
                                        />
                                      </OverlayTrigger>
                                    )}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div
                                  className="col-lg-1 col-1 text-center"
                                  style={{ marginTop: "38px" }}
                                ></div>
                              </>
                            )
                          ) : null}
                        </div>
                        <div className="pt-2">
                          <div className="col-lg-12 col-sm-12 col-md-12">
                            <div className="px-3">
                              {" "}
                              <a
                                type="button"
                                class="btn btn-link click"
                                onClick={() => this.showModal()}
                                style={{ color: "#007bff" }}
                              >
                                {t(
                                  "ComplianceandBudgetScreen.BudgetHistoryTable"
                                )}
                              </a>
                            </div>
                          </div>
                        </div>
                        {userrole === "approver" &&
                        shipDetail.status === "Approverapprovalpending" ? (
                          <div className="row px-5">
                            <div className="col-lg-11 mt-3">
                              <label className="form-label fontstyle required">
                                {t("DashboardShipReports.Remarks")}
                              </label>
                              <br></br>
                              <textarea
                                className="form-control"
                                id="chargeRemark"
                                name="remarks"
                                value={this.state.shipInfo.remarks}
                                onChange={(e) =>
                                  this.handleInputChangeRemark(e)
                                }
                              ></textarea>
                              <span
                                id="chargeRemarkErrMsg"
                                className="spanErrMsg"
                              ></span>
                            </div>
                          </div>
                        ) : null}
                        {shipDetail.status ===
                        "Active" ? null : ContractPanelDetails?.response ==="approved" ||
                          ContractPanelDetails?.response === "rejected" ||
                          ContractPanelDetails?.response === "pending" ? (
                          <div className="row">
                            <div className="col-lg-9 mt-3">
                              <div className="px-5 py-4">
                                <div
                                  className="table-responsive"
                                  style={{ width: "100%" }}
                                >
                                  <div
                                    className={`panel ${
                                      this.state.panel_break
                                        ? `panel-width`
                                        : ``
                                    } ${
                                      ContractPanelDetails?.response ===
                                      "approved"
                                        ? `border-success`
                                        : ContractPanelDetails?.response ===
                                          "rejected"
                                        ? `border-danger`
                                        : ContractPanelDetails?.response ===
                                          "pending"
                                        ? `border-info`
                                        : ``
                                    } `} >
                                    <div
                                      className={`panel-header ${
                                        ContractPanelDetails?.response ===
                                        "approved"
                                          ? `text-success panel-success`
                                          : ContractPanelDetails?.response ===
                                            "rejected"
                                          ? `text-danger panel-danger`
                                          : ContractPanelDetails?.response ===
                                            "pending"
                                          ? `text-info panel-info`
                                          : ``
                                      }`}>
                                      <label>
                                        {" "}
                                        {t(
                                          "ComplianceandBudgetScreen.ContractStatus"
                                        )}
                                      </label>
                                    </div>
                                    <div className="card-body-panel px-3">
                                      {ContractPanelDetails?.response ===
                                      "pending" ? (
                                        <>
                                          <span className="spandoc-td py-1">
                                            <label
                                              className="text-style"
                                              style={{ fontWeight: "600" }}
                                            >
                                              {" "}
                                              {t(
                                                "ComplianceandBudgetScreen.ContactSubmitted"
                                              )}{" "}
                                            </label>
                                          </span>
                                        </>
                                      ) : null}
                                      {ContractPanelDetails?.response ===
                                        "approved" ||
                                      ContractPanelDetails?.response ===
                                        "rejected" ? (
                                        <>
                                          <span className="spandoc-td py-1">
                                            <label className="text-style">
                                              {" "}
                                              <span>
                                                {t(
                                                  "ComplianceandBudgetScreen.Contractwas"
                                                )}{" "}
                                              </span>
                                              <span>
                                                {ContractPanelDetails?.response ===
                                                "approved"
                                                  ? `${t(
                                                      "ComplianceandBudgetScreen.Approvedby"
                                                    )}`
                                                  : ContractPanelDetails?.response ===
                                                    "rejected"
                                                  ? `${t(
                                                      "ComplianceandBudgetScreen.Rejectedby"
                                                    )}`
                                                  : ""}{" "}
                                              </span>
                                              <span
                                                className={`${
                                                  this.state.break
                                                    ? `plan-text`
                                                    : ``
                                                }`}
                                                style={{ fontWeight: "600" }}
                                              >
                                                {" "}
                                                {
                                                  ContractPanelDetails?.confirmedBy
                                                }
                                              </span>
                                            </label>{" "}
                                          </span>
                                          <br />
                                          <span className="spandoc-td py-1">
                                            <label className="text-style">
                                              <span
                                                style={{ fontWeight: "600" }}
                                              >
                                                {ContractPanelDetails?.response ===
                                                "approved"
                                                  ? "Approved"
                                                  : ContractPanelDetails?.response ===
                                                    "rejected"
                                                  ? "Rejected"
                                                  : ""}{" "}
                                                {t(
                                                  "ComplianceandBudgetScreen.Zones"
                                                )}{" "}
                                                :{" "}
                                              </span>
                                              <span>
                                                {" "}
                                                {ContractPanelDetails?.zoneName}
                                              </span>
                                            </label>{" "}
                                          </span>
                                          <br />
                                          <span className="spandoc-td py-1">
                                            <label className="text-style">
                                              <span
                                                style={{ fontWeight: "600" }}
                                              >
                                                {t(
                                                  "ComplianceandBudgetScreen.Signature"
                                                )}{" "}
                                                :{" "}
                                              </span>
                                              <span className="px-2">
                                                {ContractPanelDetails?.sign ? (
                                                  <img
                                                    src={
                                                      ContractPanelDetails?.sign
                                                    }
                                                    className="cursorPointer"
                                                    style={{
                                                      width: "55px",
                                                      height: "42px",
                                                    }}
                                                  />
                                                ) : (
                                                  " "
                                                )}
                                              </span>
                                            </label>
                                          </span>
                                          <br />
                                          <span>
                                            <strong className="py-1">
                                              <lebel className="text-style">
                                                {t(
                                                  "DashboardShipReports.Remarks"
                                                )}{" "}
                                                :{" "}
                                              </lebel>
                                            </strong>
                                            <br />
                                            <span className="spandoc-td px-1 py-1">
                                              <label className="text-style">
                                                {ContractPanelDetails?.remarks
                                                  ? ContractPanelDetails?.remarks
                                                  : ""}
                                              </label>{" "}
                                            </span>
                                          </span>
                                          {this.state.AddDynamicLabel
                                            ?.length !== 0
                                            ? this.state.AddDynamicLabel.map(
                                                (x, index) => {
                                                  return (
                                                    <>
                                                      <br />
                                                      <span>
                                                        <strong className="py-1">
                                                          <lebel className="text-style">
                                                            {x?.labelName} :{" "}
                                                          </lebel>
                                                        </strong>
                                                        <span className="spandoc-td px-1 py-1">
                                                          <label className="text-style">
                                                            {x?.labelValue
                                                              ? x?.labelValue
                                                              : ""}{" "}
                                                          </label>{" "}
                                                        </span>
                                                      </span>
                                                    </>
                                                  );
                                                }
                                              )
                                            : null}
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3"></div>
                          </div>
                        ) : null}

                        {/*    {this.state.isDuplicate ? (
                      <div className="pt-3">
                        <div className="row px-5">
                          <div className="col-lg-11">
                            <div
                              className="table-responsive"
                              style={{ width: "100%" }}
                            >
                              <table
                                id="Docstable example1"
                                className="table table-borderless border-top border-bottom border-left border-right"
                              >
                                <thead>
                                  <tr className="border-top section-color spandoc-thead">
                                    {Budgetable.filter(
                                      (item, index) =>
                                        index === Budgetable.length - 1
                                    ).map((k, ind) =>
                                      k.map((i, index) => (
                                        <>
                                          <th
                                            className=" text-center align-middle border-right border-left"
                                            scope="col"
                                          >
                                            {i.zoneName}{" "}
                                          </th>
                                        </>
                                      ))
                                    )}
                                  </tr>
                                </thead>
                                <tbody className="table-body">
                                  <tr className="border-top">
                                    {Budgetable &&
                                      Budgetable.filter(
                                        (item, index) =>
                                          index === Budgetable.length - 1
                                      ).map((l, ind) =>
                                        l.map((m, index) => (
                                          <>
                                            <td className="commentsrequire-td2 align-middle border-right">
                                              <span className="spandoc-td">
                                                <CssTextField
                                                  multiline
                                                  fullWidth
                                                  variant="outlined"
                                                  type="text"
                                                  onChange={(e) =>
                                                    this.handleInputChange1(
                                                      e,
                                                      m
                                                    )
                                                  }
                                                  onBlur={(e) =>
                                                    this.UpdateBudget(e, m)
                                                  }
                                                  value={m?.price}
                                                  InputProps={{
                                                    className: `border-radius padding-space`,
                                                  }}
                                                />
                                              </span>
                                            </td>
                                          </>
                                        ))
                                      )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null} */}
                      </div>
                    ) : null}
                    {userrole == Role.mmpladmin ||
                    (userrole == Role.approver &&
                      shipDetail.status === "Approverapprovalpending") ? (
                      <div className="pb-4 pl-4 pr-4 mt-2">
                        <div
                          className="search-btn-col"
                          style={{ textAlign: "end" }}>
             {/* <button className="btn btn-primary text-uppercase" onClick={() => this.gotoview()}>
                            goto</button>  */}
                          {(userrole === "admin" &&
                            shipDetail.status === "Initiatecontractpending" &&
                            !ContractPanelDetails?.response) ||
                          (userrole === "admin" &&
                            shipDetail.status === "Initiatecontractpending" &&
                            ContractPanelDetails?.response === "rejected") ? (
                            <>
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-1 mr-3"
                                type="submit"
                                onClick={() => this.showEditTermsModal(true)}
                              >
                                {" "}
                                {t("BudgetListOverview.EditTermsCondition")}
                              </button>
                            </>
                          ) : null}
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-1"
                            type="submit"
                            onClick={() => this.ExportExcel(shipDetail.shipName,this.state.isContract,this.state.isNotContract,this.state.isbothContract)}
                          >
                            {" "}
                            {t("ComplianceandBudgetScreen.ExportExcel")}{" "}
                          </button>
                          {userrole === "approver" &&
                          shipDetail.status === "Approverapprovalpending" ? (
                            <>
                              <button
                                className="btn btn-success text-uppercase txtside-btn txtht-btn ml-3 mt-1"
                                type="submit"
                                onClick={() => this.ApproveBudget()}
                              >
                                {" "}
                                {t("ComplianceandBudgetScreen.Approve")}{" "}
                              </button>
                              <button
                                className="btn btn-danger text-uppercase txtside-btn txtht-btn ml-3 mt-1"
                                type="button"
                                onClick={() => this.RejectBudget()}
                              >
                                {" "}
                                {t("ComplianceandBudgetScreen.Reject")}{" "}
                              </button>
                            </>
                          ) : null}
                          {userrole === "admin" ? ((ContractPanelDetails?.response === "pending" &&
                              shipDetail.status == "Clientapprovalpending")?(<>
                              <button className={`btn text-uppercase btn-primary txtside-btn txtht-btn ml-3 mt-1`} type="button"
                                  onClick={() => this.ResendEmail()}>{" "}
                                  {t("ComplianceandBudgetScreen.ResendEmail")}{" "}
                                  </button>
                              </>):null):null}

                          {userrole === "admin" ? (
                            (shipDetail.status === "Initiatecontractpending" &&
                              !ContractPanelDetails?.response) ||
                            (ContractPanelDetails?.response === "pending" &&
                              shipDetail.status == "Clientapprovalpending") ||
                            (shipDetail.status === "Initiatecontractpending" &&
                              ContractPanelDetails?.response === "rejected") ? (
                              <>
                                <button
                                  className={`btn text-uppercase txtside-btn txtht-btn ml-3 mt-1 ${
                                    ContractPanelDetails?.response ===
                                      "pending" &&
                                    shipDetail.status == "Clientapprovalpending"
                                      ? `disable editicon`
                                      : `btn-primary`
                                  }`}
                                  type="button"
                                  onClick={() => this.showContractModal()}
                                >
                                  {" "}
                                  {t(
                                    "ComplianceandBudgetScreen.InitiateContract"
                                  )}{" "}
                                </button>
                              </>
                            ) : null
                          ) : null}
                          {userrole === "admin" &&
                            shipDetail.status === "Initiatecontractpending" &&
                            ContractPanelDetails?.response === "rejected"?(
                            <>
                              <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3 mt-1" type="submit"
                               onClick={() => this.AssignGrandAdmin()}>{" "}
                                  {t("ShipManagementContent.AssigntoCoordinator")}{" "}
                             </button>
                            </>
                            ):null}
                          {userrole === "admin" ? (
                            shipDetail.status ===
                            "Active" ? null : ContractPanelDetails?.response ===
                                "approved" &&
                              shipDetail.status === "Clientapproved" ? (
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn ml-3 mt-1"
                                type="submit"
                                onClick={() => this.SubmitContract("submit")}
                              >
                                {" "}
                                {t("ComplianceandBudgetScreen.Submit")}{" "}
                              </button>
                            ) : null
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    zoneList: state.VendorManagementReducer.zoneList,
    shipDetail: state.ShipEquipmentReducer.ShipDetail || {},
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
    mmplHistorySearchResult:
      state.MMPLDashboardReducer.MMPLHistorySearchResult || null,
    applicableServiceType:
      state.MasterScreenReducer.applicableServiceTypeInterval,
    EquipmentZoneList: state.ShipEquipmentReducer.EquipmentZoneList,
    applicableServiceTypeBudget:
      state.MasterScreenReducer.applicableServiceTypeBudget,
    ContractPanelDetails: state.ShipEquipmentReducer.ContractPanelDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(BudgetListView)
);
